'use strict';
//============================================================ SETUP
const cv=document.getElementById('fred-game-canvas');let ctx=cv.getContext('2d'); // let : ctx bascule temporairement vers un canvas offscreen (banniere de l'avion)
ctx.imageSmoothingEnabled=false;
const W=320,H=180,GROUND=152,HORIZON=112,BASEX=128; // skater aux 2/5 de l'ecran
// ===== MARKETING : texte de la banniere tiree par l'avion (editer ici) =====
// Majuscules/chiffres/ponctuation presents dans FONT uniquement ; longueur conseillee <= 28 caracteres
// pour que l'ensemble avion+banniere reste sous ~180 px de large.
const BANNER_TXT='FREE SHIPPING TO CANADA';
const IS_MOBILE=matchMedia('(pointer:coarse)').matches||'ontouchstart' in window;
const rnd=(a,b)=>a+Math.random()*(b-a);
const irnd=(a,b)=>Math.floor(rnd(a,b+1));
function px(x,y,w,h,c){ctx.fillStyle=c;ctx.fillRect(x|0,y|0,w,h);}
function mix(c1,c2,t){
  const p=h=>[parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)];
  const A=p(c1),B=p(c2);
  return 'rgb('+A.map((v,i)=>(v+(B[i]-v)*t)|0).join(',')+')';
}
//============================================================ 3x5 PIXEL FONT
const FONT={
A:["010","101","111","101","101"],B:["110","101","110","101","110"],C:["011","100","100","100","011"],
D:["110","101","101","101","110"],E:["111","100","110","100","111"],F:["111","100","110","100","100"],
G:["011","100","101","101","011"],H:["101","101","111","101","101"],I:["111","010","010","010","111"],
J:["001","001","001","101","010"],K:["101","110","100","110","101"],L:["100","100","100","100","111"],
M:["101","111","101","101","101"],N:["110","101","101","101","101"],O:["010","101","101","101","010"],
P:["110","101","110","100","100"],Q:["010","101","101","110","011"],R:["110","101","110","110","101"],
S:["011","100","010","001","110"],T:["111","010","010","010","010"],U:["101","101","101","101","111"],
V:["101","101","101","101","010"],W:["101","101","101","111","101"],X:["101","101","010","101","101"],
Y:["101","101","010","010","010"],Z:["111","001","010","100","111"],
"0":["111","101","101","101","111"],"1":["010","110","010","010","111"],"2":["110","001","010","100","111"],
"3":["110","001","010","001","110"],"4":["101","101","111","001","001"],"5":["111","100","110","001","110"],
"6":["011","100","110","101","010"],"7":["111","001","010","010","010"],"8":["111","101","111","101","111"],
"9":["010","101","011","001","110"],
"!":["010","010","010","000","010"],".":["000","000","000","000","010"],",":["000","000","000","010","100"],
":":["000","010","000","010","000"],"-":["000","000","111","000","000"],"+":["000","010","111","010","000"],
"=":["000","111","000","111","000"],"/":["001","001","010","100","100"],"'":["010","010","000","000","000"],
"(":["010","100","100","100","010"],")":["010","001","001","001","010"],
"?":["110","001","010","000","010"],
"&":["010","101","010","101","011"]
};
const textW=(s,sc=1)=>s.length*4*sc-sc;
function text(s,x,y,c,sc=1){
  s=(''+s).toUpperCase();let cx=x|0;
  for(const ch of s){
    const g=FONT[ch];
    if(g)for(let r=0;r<5;r++)for(let k=0;k<3;k++)if(g[r][k]=='1')px(cx+k*sc,y+r*sc,sc,sc,c);
    cx+=4*sc;
  }
}
function textC(s,cxp,y,c,sc=1){text(s,cxp-textW(s,sc)/2,y,c,sc);}
function textSh(s,x,y,c,sh,sc=1){text(s,x+sc,y+sc,sh,sc);text(s,x,y,c,sc);}
function textCSh(s,cxp,y,c,sh,sc=1){const x=cxp-textW(s,sc)/2;text(s,x+sc,y+sc,sh,sc);text(s,x,y,c,sc);}
//============================================================ COLORS
const C={deck:'#ff2975',grip:'#1a1a2e',wheel:'#ffe9f7',skin:'#ffcf9f',shirt:'#ffd319',
         pant:'#3d4266',shoe:'#ffffff',cap:'#00fff0',eye:'#1a1a2e'};
//============================================================ STATIC BACKGROUND
const bgSky=document.createElement('canvas');bgSky.width=W;bgSky.height=H;
{
  const b=bgSky.getContext('2d');
  for(let y=0;y<HORIZON;y++){
    const t=y/HORIZON;
    b.fillStyle=t<.5?mix('#0d0221','#45125e',t*2):mix('#45125e','#ff4d6d',(t-.5)*2);
    b.fillRect(0,y,W,1);
  }
  b.fillStyle='#100722';b.fillRect(0,HORIZON,W,GROUND-HORIZON);
  b.fillStyle='#1c1333';b.fillRect(0,GROUND,W,H-GROUND);
}
const stars=[...Array(42)].map(()=>({x:irnd(0,W),y:irnd(2,78),p:rnd(0,6),s:Math.random()<.2?2:1}));
function mkBuild(hMin,hMax,wMin,wMax,dens){
  const a=[];let x=0;
  while(x<720){
    const w=irnd(wMin,wMax),h=irnd(hMin,hMax),wins=[];
    for(let wy=4;wy<h-4;wy+=5)for(let wx=3;wx<w-3;wx+=5)
      if(Math.random()<dens)wins.push([wx,wy,Math.random()<.22?1:0]);
    a.push({x,w,h,wins});x+=w+irnd(2,10);
  }
  return{list:a,L:x};
}
const FAR=mkBuild(26,66,18,34,.36),NEAR=mkBuild(12,36,24,52,.14);
const ST=(()=>{ // motifs de rue precalcules, cycle de 1200px
  const CY=1200,j=[],gr=[],man=[],pud=[],sp=[];
  for(let x=irnd(10,30);x<CY;x+=irnd(38,64))j.push(x);
  for(let i=0;i<5;i++)gr.push(irnd(0,CY));
  for(let i=0;i<4;i++)man.push(irnd(0,CY));
  for(let i=0;i<3;i++)pud.push({x:irnd(0,CY),w:irnd(14,24)});
  for(let i=0;i<90;i++)sp.push({x:irnd(0,CY),y:irnd(2,20),w:irnd(1,3),c:Math.random()<.25?'#241a3e':'#0f0a1e'});
  return{CY,j,gr,man,pud,sp};
})();
const stWrap=v=>((v%ST.CY)+ST.CY)%ST.CY;
const SUNCUT=new Set([1,2,5,6,9,13,17]);
//============================================================ GAME STATE
let frame=0,state='splash',splashT=0,score=0,hi=0,dist=0,lives=3,speed=1.8,shake=0;
let obs=[],parts=[],pops=[],chain=null,sinceSpawn=0,nextGap=200,playT=0,overF=0,newHi=false,held=false,firstRun=true;
let bgDist=0,camS=0,outroT=0,stopT=0,fakieMul=1,gapIdx=-1,gapTouched=false,bgPend=false;
const P={x:BASEX,y:GROUND,vy:0,air:false,grind:null,trick:null,inv:0,crash:0,pushT:0,
         man:0,manNose:false,manBias:0,bal:0,lean:0,rot:0,slide:0,rev:0,crouch:0,popV:3,aoll:0,fixLean:0,preL:0,preR:0,fakie:false,apex:GROUND,takeoffY:GROUND,jumpFromY:GROUND,airDown:false,charged:false,relandMan:false,spinJump:false,spinCount:0,spinDir:1,wall:null,wallT:0,wallCD:0,wallEntry:0,wallBS:0,wallDir:0,wallCoast:0};
const KD={l:false,r:false,u:false,d:false}; // posture de la planche
let grindStartF=0,lastDownF=-1,pendL=false,pendR=false,bridgeCount=0,wallDone=false,upL=false,upR=false,armL=false,armR=false;
const LINKMAX=54; // fenetre de lien du combo (frames @60fps ~ 0.9s)
// une structure au sol (ledge/plateau) ne doit pas chevaucher une intersection
function spansCross(a,bb){for(let k=1;k*CROSSPER<LEVEL;k++){const cs=k*CROSSPER;if(a<cs+CROSSLEN&&bb>cs-8)return true;}return false;}
let demo=false,idleT=0,demoNext=0,dLean=0,dManT=0; // mode demo (attract)
//============================================================ AUDIO
const AU={c:null,mut:false,next:0,step:0,gr:null,master:null,nbuf:null};
function ac(){
  if(!AU.c){
    try{AU.c=new(window.AudioContext||window.webkitAudioContext)();}catch(e){return;}
    AU.master=AU.c.createGain();AU.master.gain.value=.16;AU.master.connect(AU.c.destination);
    const len=AU.c.sampleRate|0,buf=AU.c.createBuffer(1,len,AU.c.sampleRate),d=buf.getChannelData(0);
    for(let i=0;i<len;i++)d[i]=Math.random()*2-1;
    AU.nbuf=buf;AU.next=AU.c.currentTime+.06;
  }
  if(AU.c.state==='suspended')AU.c.resume();
}
function tone(type,f0,f1,dur,vol,when=0){
  if(!AU.c||AU.mut)return;
  const t=AU.c.currentTime+when,o=AU.c.createOscillator(),g=AU.c.createGain();
  o.type=type;o.frequency.setValueAtTime(f0,t);
  if(f1)o.frequency.exponentialRampToValueAtTime(Math.max(f1,1),t+dur);
  g.gain.setValueAtTime(vol,t);g.gain.exponentialRampToValueAtTime(.001,t+dur);
  o.connect(g);g.connect(AU.master);o.start(t);o.stop(t+dur+.02);
}
function noiseHit(dur,vol,freq,type,when=0){
  if(!AU.c||AU.mut)return;
  const t=AU.c.currentTime+when,s=AU.c.createBufferSource(),f=AU.c.createBiquadFilter(),g=AU.c.createGain();
  s.buffer=AU.nbuf;s.loop=true;f.type=type||'bandpass';f.frequency.value=freq;
  g.gain.setValueAtTime(vol,t);g.gain.exponentialRampToValueAtTime(.001,t+dur);
  s.connect(f);f.connect(g);g.connect(AU.master);s.start(t);s.stop(t+dur+.02);
}
const sJump=()=>tone('square',170,520,.12,.35);
const sFlip=()=>{tone('triangle',600,900,.07,.3);tone('triangle',900,1300,.07,.25,.06);};
const sTrickDone=()=>tone('square',990,1450,.08,.22);
const sLand=()=>noiseHit(.06,.22,500,'lowpass');
const sBank=()=>{tone('square',880,0,.06,.3);tone('square',1318,0,.12,.3,.06);};
const sCrash=()=>{tone('sawtooth',260,40,.35,.5);noiseHit(.3,.3,900,'lowpass');};
const sGrindHit=()=>tone('square',330,660,.08,.3);
function grindStart(){
  if(!AU.c||AU.mut||AU.gr)return;
  const s=AU.c.createBufferSource(),f=AU.c.createBiquadFilter(),g=AU.c.createGain();
  s.buffer=AU.nbuf;s.loop=true;f.type='bandpass';f.frequency.value=2400;f.Q.value=1.2;
  g.gain.value=.10;s.connect(f);f.connect(g);g.connect(AU.master);s.start();
  AU.gr={s};
}
function grindStop(){if(AU.gr){try{AU.gr.s.stop();}catch(e){}AU.gr=null;}}
// wall ride : accroche sur la face verticale d'un ledge/plateau (declenche a la fleche Haut)
function startWallride(o){
  P.wall=o;P.wallT=0;P.wallBS=0;P.wallDir=-1;P.wallCoast=12;P.air=false;P.vy=0;settleTrick();P.grind=null;bgPend=false;
  if(!chain)chain=newChain();chain.cnt++;
  pops.push({x:P.x,y:P.y-26,t:(P.fakie?'FAKIE ':'')+'WALL RIDE!',c:'#ffd319',l:34,s:1});
  sGrindHit();grindStart();awardOver();
}
// -- music: 140bpm 8ths, chords A F C G
const STEP=60/140/2,ROOTS=[0,8,3,10];
const BASS=[0,null,0,12,null,0,10,12];
const LEAD=[12,null,15,19,null,15,12,null, 8,null,12,15,null,12,8,null,
            7,null,10,15,null,19,15,10,  10,null,14,17,null,14,22,null];
function tickMusic(){
  if(!AU.c||AU.mut)return;
  if(state!=='play'&&state!=='title'&&state!=='outro')return;
  const now=AU.c.currentTime;
  const mBoost=chain?Math.min(6,chain.cnt):0; // le lead s'intensifie avec le multiplicateur de combo
  if(AU.next<now-.3)AU.next=now+.05;
  while(AU.next<now+.13){
    const i=AU.step%32,pos=i&7,root=ROOTS[i>>3],w=AU.next-now;
    const b=BASS[pos];
    if(b!=null)tone('square',55*Math.pow(2,(root+b)/12),0,.19,.4,w);
    if(pos===0||pos===4)tone('sine',110,40,.1,.6,w);
    if(pos===2||pos===6)noiseHit(.07,.16,1800,'highpass',w);
    noiseHit(.03,.05,6200,'highpass',w);
    const L=LEAD[i];
    if(L!=null){
      tone('square',220*Math.pow(2,L/12),0,.16,.10+mBoost*0.012,w);
      tone('square',220*Math.pow(2,L/12),0,.14,.045,w+STEP*1.5);
    }
    AU.step++;AU.next+=STEP;
  }
}
//============================================================ GAME LOGIC
function startGame(){
  state='play';score=0;dist=0;lives=3;speed=1.8;
  bgDist=0;camS=0;outroT=0;stopT=0;fakieMul=1;P.x=BASEX;
  obs=[];parts=[];pops=[];npcs=[];npcT=180;npcSaid={};chain=null;sinceSpawn=0;nextGap=220;playT=0;
  P.y=GROUND;P.vy=0;P.air=false;P.trick=null;P.grind=null;P.wall=null;P.wallT=0;P.inv=0;P.crash=0;P.pushT=0;
  P.man=0;P.manNose=false;P.bal=0;P.lean=0;P.rot=0;P.slide=0;P.rev=0;P.crouch=0;P.aoll=0;P.fixLean=0;P.fakie=false;P.apex=GROUND;P.takeoffY=GROUND;P.spinCount=0;P.spinDir=1;
  grindStartF=0;lastDownF=-1;bridgeCount=0;wallDone=false;train=null;trainDone=false;gapIdx=-1;gapTouched=false;bgPend=false;P.airTrickLbl=null;
  grindStop();
}
function spawn(){
  if(train&&train.x<W+60&&train.x+TR_W>W-20)return; // toit du train sur la zone de spawn : jamais de sol de reference train (obstacles flottants sinon)
  const wpos=dist+(W+20-BASEX);
  const cm=(wpos+80)%CROSSPER;
  if(wpos>CROSSPER-80&&cm<CROSSLEN+120)return; // pas d'obstacles dans (ni juste avant) une intersection
  const sx=W+20,base=groundAt(sx),elev=base<GROUND;
  const r=Math.random();
  // pont sureleve (viaduc Meatpacking) : 2 par partie, tres long, rails dessus, drop au bout
  if(!elev&&bridgeCount<2&&!train&&dist>(bridgeCount===0?1500:LEVEL/2)){ // jamais de pont pendant le train (rails du tablier a hauteur du toit)
    const len=760,g=GROUND-44;
    obs.push({x:sx,w:len,h:44,k:'bridge'});
    const endLim=len-40; // les rails du tablier s'arretent avant le drop du pont
    for(const [rx,rw] of [[150,150],[380,170],[600,130]]){
      const w=Math.min(rw,endLim-rx);
      if(w>=50)obs.push({x:sx+rx,w,h:11,rail:true,gy:g});
    }
    bridgeCount++;
    sinceSpawn=-(len+220); // rien d'autre ne spawn le temps que le pont passe
    return;
  }
  // long mur : 1 par partie, pour un gros wall ride le long de sa face (parallele a la rue)
  if(!elev&&!wallDone&&dist>2600&&dist<LEVEL-1800){
    const w=460;
    if(!spansCross(wpos,wpos+w)){
      obs=obs.filter(o=>o.k==='wall'||o===P.grind||o===P.wall||o.x+o.w<=P.x); // approche propre : rien d'autre devant le mur (mais garder l'obstacle en cours d'utilisation)
      obs.push({x:sx,w,h:46,k:'wall'});
      wallDone=true;
      sinceSpawn=-(w-20); // laisser tout le mur defiler
      return;
    }
  }
  if(!elev&&dist>600&&r<.20){ // long plateau sureleve (~500px)
    const topLen=irnd(420,520),stairLen=35,w=topLen+stairLen;
    if(!spansCross(wpos,wpos+w)){ // ne pas chevaucher une intersection
      obs.push({x:sx,w,topLen,stairLen,steps:5,h:22,k:'stairs'});
      return;
    }
  }
  else if(!elev&&dist>600&&r<.46){ // ledges : plus frequents, longueurs et hauteurs variees
    const topLen=irnd(50,150),stairLen=irnd(24,32),w=topLen+stairLen,h=irnd(14,22);
    if(!spansCross(wpos,wpos+w)){
      obs.push({x:sx,w,topLen,stairLen,steps:irnd(3,5),h,k:'stairs'});
      sinceSpawn=-w;
      return;
    }
  }
  // place restante sur un plateau : eviter les rails qui depassent la descente
  let maxLen=999;
  if(elev)for(const o of obs){
    if(o.k==='stairs'&&sx>=o.x&&sx<o.x+o.topLen)maxLen=Math.min(maxLen,o.x+o.topLen-sx-10);
    if(o.k==='bridge'&&sx>=o.x&&sx<o.x+o.w)maxLen=Math.min(maxLen,o.x+o.w-40-sx); // ne pas depasser le tablier
  }
  // un rail au sol ne doit ni croiser ni finir dans une intersection
  if(!elev)for(let k=1;k*CROSSPER<LEVEL;k++){const cs=k*CROSSPER;if(wpos<cs+CROSSLEN){maxLen=Math.min(maxLen,wpos<cs-8?cs-8-wpos:0);break;}}
  const pk=Math.random();
  if(pk<.34&&maxLen>=70)obs.push({x:sx,w:Math.min(irnd(70,120),maxLen),h:11,rail:true,gy:base});
  else if(pk<.48&&maxLen>=180){ // long rail bas
    const len=Math.min(irnd(180,260),maxLen);
    obs.push({x:sx,w:len,h:11,rail:true,gy:base});
    sinceSpawn=-(len-80);
  }
  else if(pk<.60&&maxLen>=180&&!elev){ // long rail haut
    const len=Math.min(irnd(180,260),maxLen);
    obs.push({x:sx,w:len,h:18,rail:true,gy:base});
    sinceSpawn=-(len-80);
  }
  else if(pk<.72)obs.push(elev?{x:sx,w:12,h:13,k:'trash',gy:base}:{x:sx,w:8,h:12,k:'hyd',gy:base}); // une borne-fontaine pousse dans le trottoir, jamais sur un plateau
  else if(pk<.84)obs.push({x:sx,w:12,h:13,k:'trash',gy:base});
  else if(pk<.92)obs.push({x:sx,w:28,h:14,k:'bins',gy:base}); // duo de poubelles habitees
  else obs.push({x:sx,w:22,h:10,k:'barrier',gy:base});
}
// ===== TRAIN passager (1 par partie) : 5 wagons a contresens, derriere les obstacles, toit ridable =====
const TR_H=48,TR_WL=100,TR_GAP=6,TR_N=10,TR_W=TR_N*TR_WL+(TR_N-1)*TR_GAP,TR_V=0.6,TR_BEV=8,TR_DIP=10;
let train=null,trainDone=false; // hors de obs[] : aucune interaction avec spawn/filtres/grinds (regles 1 et 2 sauves par construction)
function trainTopAt(x){ // hauteur du toit a la position ecran x (null hors de l'emprise du train)
  if(!train)return null;
  const r=x-train.x;
  if(r<0||r>=TR_W)return null;
  const u=r%(TR_WL+TR_GAP),roof=GROUND-TR_H;
  if(u>=TR_WL)return roof+TR_DIP;                            // creux d'attelage entre wagons (mini-gap)
  if(u<TR_BEV)return roof+TR_DIP*(1-u/TR_BEV);               // biseau d'attaque (rampe praticable)
  if(u>TR_WL-TR_BEV)return roof+TR_DIP*(1-(TR_WL-u)/TR_BEV); // biseau arriere
  return roof;                                               // toit plat
}
function surfacesAt(x){ // toutes les surfaces empilees a cette position
  const s=[crossM(dist+(x-BASEX))<CROSSLEN?GROUND+CROSSDROP:GROUND];
  const tv=trainTopAt(x);if(tv!==null)s.push(tv); // toit du train (mobile : recalcule chaque frame)
  for(const o of obs){
    if(o.k==='bridge'){ if(x>=o.x&&x<o.x+o.w)s.push(GROUND-o.h); continue; } // pont : dessus plat, drop au bout
    if(o.k!=='stairs')continue;
    const te=o.x+o.topLen;
    if(x>=o.x&&x<te)s.push(GROUND-o.h);
    else if(x>=te&&x<o.x+o.w){
      const idx=Math.min(o.steps-1,((x-te)/(o.stairLen/o.steps))|0);
      s.push(GROUND-o.h+(idx+1)*(o.h/o.steps));
    }
  }
  return s;
}
// sans y : surface la plus haute (spawn, decor). Avec y : premiere surface sous les pieds
// (un ledge devant lequel on passe n'est pas un sol tant qu'on n'a pas saute dessus)
function groundAt(x,y){
  const s=surfacesAt(x);
  if(y===undefined)return Math.min(...s);
  let best=1e9;
  for(const v of s)if(v>=y-2&&v<best)best=v;
  return best===1e9?Math.max(...s):best;
}
// peut-on s'accrocher/atterrir sur une surface surelevee de sommet topY ?
// oui si on a decolle de ce niveau (ou plus haut), ou si on l'a franchie proprement (hors trick)
function canMount(topY){
  if(P.takeoffY<=topY+2)return true;            // on vient deja de ce niveau (ou plus haut)
  if(P.apex<=topY+4 && !P.trick)return true;    // on l'a franchi (petite tolerance de rattrapage sur la levre)
  // (l'ancienne regle "pont = charge obligatoire" est retiree : l'ollie a -3.0 ne
  // franchit le tablier qu'en flottant, la hauteur fait office de barriere a elle seule)
  return false;
}
// surface d'atterrissage en l'air : detecte la surface FRANCHIE entre preY et P.y
// (evite de traverser un dessus de ledge quand la descente est rapide). Sureleve seulement si canMount.
function landY(x,preY){
  const s=surfacesAt(x),base=Math.max(...s);
  let pick=base; // la rue rattrape toujours quand P.y l'atteint
  for(const v of s)
    if(v<pick && P.y>=v-0.5 && preY<=v+3 && (v>=base-0.5||canMount(v)))pick=v;
  return pick;
}
function railGeom(o){
  const te=o.x+o.topLen;
  return{x0:te-6,y0:GROUND-o.h-10,x1:te+o.stairLen+8,y1:GROUND-10};
}
function railYAt(g,x){return g.y0+(g.y1-g.y0)*(x-g.x0)/(g.x1-g.x0);}
function doTrick(name,label,dur,pts){
  if(P.fakie){ // nomenclature fakie + bonus de 50%
    if(name==='bs180')label='HALF CAB';
    else if(name==='fs180')label='FS HALF CAB';
    else label='FAKIE '+label;
    pts=Math.round(pts*1.5);
  }
  P.trick={name,label,dur,pts,t:0};P.aoll=0;sFlip();
}
// chaque 180 : inverse la direction (fakie) ET l'equilibre (aoll). Applique une fois par demi-tour.
function applySpinFlip(){P.fakie=!P.fakie;if(P.aoll)P.aoll=-P.aoll;}
// fleche tenue + espace = 180 ; chaque espace supplementaire ajoute un 180 (360, 540...). dir=-1 gauche(BS), +1 droite(FS)
function spin180(dir){
  if((P.spinCount||0)>=6)return; // plafond a 1080 (6 demi-tours) : evite l'empilage abusif
  if(P.trick&&P.trick.name==='spin')applySpinFlip(); // clot le 180 precedent avant d'en relancer un
  P.spinCount=(P.spinCount||0)+1;P.spinDir=dir;
  let pts=P.spinCount===1?35:45,label=(dir<0?'BS ':'FS ')+(P.spinCount*180);
  if(P.fakie&&P.spinCount===1){label=dir<0?'HALF CAB':'FS HALF CAB';pts=Math.round(pts*1.5);}
  P.trick={name:'spin',label,dur:14,pts,t:0};sFlip(); // ne touche PAS a P.aoll (porte le manual)
}
function startManual(nose){
  P.man=1;P.manNose=nose;P.bal=0;P.manBias=nose?-.006:.006;
  if(!chain)chain=newChain();
  chain.cnt++;
  pops.push({x:P.x,y:P.y-28,t:(P.fakie?'FAKIE ':'')+(nose?'NOSE MANUAL!':'MANUAL!'),c:'#ffd319',l:35,s:1});
  tone('square',520,780,.08,.25);
}
function newChain(){return{pts:0,cnt:0,link:LINKMAX,linkMax:LINKMAX,best:0};}
// near-miss : frole un cone / un kid en trottinette (style, +pts, +1 element, recharge la jauge)
function nearMiss(pts,label){
  if(!chain)chain=newChain();
  chain.pts+=pts;chain.cnt++;chain.link=chain.linkMax;
  pops.push({x:P.x,y:P.y-30,t:label,c:'#00fff0',l:36,s:1});
  tone('square',700,1400,.06,.22);tone('square',1050,1600,.05,.18,.05);
}
function addChainPts(label,pts){
  if(!chain)chain=newChain();
  chain.pts+=pts;chain.cnt++;chain.link=chain.linkMax;
  pops.push({x:P.x,y:P.y-28,t:label+'!',c:'#ffd319',l:38,s:1});
  sTrickDone();
}
// valide un trick encore en rotation (accroche rail/mur) : memes regles qu'a l'atterrissage, points comptes, pas de bail
function settleTrick(){
  if(!P.trick)return;
  if(!chain)chain=newChain();
  chain.pts+=P.trick.pts;chain.cnt++;
  P.airTrickLbl=P.trick.label;
  if(P.trick.name==='spin')applySpinFlip();
  P.trick=null;P.airTricked=true;sTrickDone();
}
function jump(v){P.airDown=false;P.jumpFromY=P.y;P.air=true;P.vy=v;P.popV=-v;P.man=0;P.crouch=0;P.pushT=0;P.rot=0;P.aoll=0;P.overCnt=0;P.airTricked=false;P.airTrickLbl=null;bgPend=false;P.charged=false;P.relandMan=false;P.spinJump=false;P.spinCount=0;sJump();}
// BIG GAP : sans trick = bonus classique ; avec un trick reussi pendant le saut = annonce fusionnee + bonus
function bigGapAward(lbl){
  if(lbl){ // trick + gap : 150 (gap) + 100 (style) en plus des points du trick deja comptes
    if(!chain)chain=newChain();
    chain.pts+=250;chain.cnt++;chain.link=chain.linkMax;
    pops.push({x:P.x,y:P.y-34,t:lbl+' OVER BIG GAP!!!',c:'#ff2975',l:55,s:2});
    sTrickDone();
    tone('square',300,1200,.25,.35);tone('square',600,1600,.2,.25,.08);tone('square',900,2000,.18,.22,.16);
    shake=4;
  }else{
    addChainPts('BIG GAP',150);
    tone('square',300,1200,.25,.35);tone('square',600,1600,.2,.25,.08);shake=3;
  }
}
function awardOver(){
  if(P.overCnt){
    addChainPts(P.overCnt>1?'OVER X'+P.overCnt:'OVER',P.overCnt*(P.airTricked?40:20));
    P.overCnt=0;
  }
}
function rotLandOK(){const m=Math.abs(P.rot)%180;return m<50||m>130;}
function demoAirTrick(){
  const t=[['kick','KICKFLIP',22,50],['heel','HEELFLIP',22,50],['vkick','VARIAL KICKFLIP',24,70],
           ['imposs','IMPOSSIBLE',26,80],['grab','MELON GRAB',26,40],['ngrab','NOSE GRAB',26,50],
           ['tgrab','TAIL GRAB',26,50],['shuv','POP SHUVIT',18,40]][irnd(0,7)];
  doTrick(t[0],t[1],t[2],t[3]);
}
function demoAI(){
  // remonter la bordure de l'intersection
  const cb=crossEndScreen(dist+(P.x-BASEX));
  if(!P.air&&!P.grind&&cb>P.x&&cb-P.x<36+speed*8&&frame>demoNext){
    demoNext=frame+24;jump(-2.4);return;
  }
  if(P.grind){ // sortir du rail vers la fin, parfois avec un trick
    const r=P.grind,end=r.k==='stairs'?railGeom(r).x1:r.x+r.w;
    if(end-P.x<26&&frame>demoNext){
      demoNext=frame+20;
      P.grind=null;P.lean=0;grindStop();P.air=true;P.vy=-3.0;P.popV=3;sJump();
      if(Math.random()<.6)demoAirTrick();
      else if(Math.random()<.5)P.aoll=Math.random()<.5?-1:1;
    }
    return;
  }
  if(P.air||P.crash>0)return;
  let nxt=null;
  for(const o of obs)if(o.x+o.w>P.x-4&&(nxt===null||o.x<nxt.x))nxt=o;
  const dx=nxt?nxt.x-P.x:999;
  if(nxt&&dx>0&&dx<52+speed*14&&frame>demoNext){
    demoNext=frame+30;P.man=0;
    if(nxt.rail){
      const v=Math.random();
      dLean=v<.33?-1:v<.66?1:0;
      jump(-(nxt.h>14?4.1:3.4));
      if(Math.random()<.45)demoAirTrick();
    }else if(nxt.k==='stairs'){
      jump(-4.2);
      if(Math.random()<.35)demoAirTrick();
    }else{
      jump(-(3.3+Math.random()*.9));
      demoAirTrick();
    }
  }else if(!P.man&&dx>150&&Math.random()<.005){
    startManual(Math.random()<.5);dManT=irnd(40,80);
  }
}
function bankRot(){
  const n=Math.round(Math.abs(P.rot)/180);
  if(n>0)addChainPts((P.rot<0?'BS ':'FS ')+(n*180),n*40);
  P.rot=0;
}
function wipeout(){
  if(demo){P.trick=null;P.aoll=0;P.bal=0;return;} // pas de bail en demo
  grindStop();sCrash();
  shake=9;chain=null;bgPend=false;P.trick=null;P.grind=null;P.wall=null;P.man=0;P.rot=0;P.slide=0;P.rev=0;P.lean=0;P.crouch=0;P.aoll=0;
  P.vy=0;P.y=GROUND;P.air=false;P.crash=50;
  for(let i=0;i<14;i++)parts.push({x:P.x+rnd(-6,6),y:P.y-rnd(0,16),vx:rnd(-1.5,1.5),vy:rnd(-2.6,-.4),l:irnd(15,35),c:['#ffd319','#ff2975','#ffffff'][i%3]});
}
function landChain(){
  if(!chain)return;
  const M=Math.min(10,Math.max(1,chain.cnt));
  const tot=(chain.pts*M)|0;
  if(tot>0){
    score+=tot;
    pops.push({x:P.x,y:P.y-30,t:'+'+tot+(M>1?' X'+M:''),c:'#ffd319',l:55,s:chain.cnt>2?2:1});
    sBank();
  }
  chain=null;
}
const LEVEL=10000,PXM=10; // tableau: 1000m de bitume (10px = 1m)
const CROSSPER=1500,CROSSLEN=120,CROSSDROP=6; // gap franchissable de justesse a l'ollie charge
function crossM(w){return w>=CROSSPER?w%CROSSPER:CROSSPER;} // position dans le cycle (>=CROSSLEN si hors traversee)
function crossEndScreen(w){ // x ecran de la bordure de remontee la plus proche (ou -999)
  const m=crossM(w);
  return m<CROSSLEN+40?BASEX+((w-m+CROSSLEN)-dist):-999;
}
function outroUpdate(){
  outroT++;
  bgDist+=1.3;               // le cityscape continue de derouler
  camS*=.94;if(camS<.03)camS=0; // le sol ralentit puis s'arrete
  dist+=camS;
  if(P.air){
    P.vy+=.16;P.y+=P.vy;
    if(P.y>=GROUND){P.y=GROUND;P.air=false;sLand();landChain();}
  }
  const targetX=W-22;
  const sv=Math.max(0,speed-camS); // le skater roule sur son elan
  P.x+=sv*Math.max(0,Math.min(1,(targetX-P.x)/50));
  for(const p of parts){p.x+=p.vx;p.y+=p.vy;p.vy+=.06;p.l--;}
  parts=parts.filter(p=>p.l>0);
  for(const p of pops){p.y-=.5;p.l--;}
  pops=pops.filter(p=>p.l>0);
  if(!P.air&&camS===0&&targetX-P.x<2){
    stopT++;
    if(stopT>120){state='over';overF=frame;newHi=score>hi;if(newHi)hi=score|0;}
  }
}
function update(){
  if(state==='outro'){outroUpdate();return;}
  playT++;
  if(dist>=LEVEL){
    state='outro';outroT=0;stopT=0;camS=speed;
    grindStop();P.grind=null;P.lean=0;P.rot=0;P.slide=0;P.rev=0;P.trick=null;P.man=0;P.pushT=40;
    if(!P.air)landChain();
    tone('square',660,0,.09,.3);tone('square',880,0,.09,.3,.09);tone('square',1320,0,.22,.3,.18);
    return;
  }
  speed=1.8+Math.min(1.08,dist/3500); // plafonne a 2.88 (-10%)
  let sp=P.crash>0?speed*.25:speed;
  const pw=dist+(P.x-BASEX);
  if(pw>CROSSPER-20&&((pw+20)%CROSSPER)<CROSSLEN+20)sp*=.65; // le jeu ralentit aux intersections
  // en fakie, pas de poussee : on ralentit fortement (plancher ~20%) mais sans s'arreter
  if(P.fakie)fakieMul=Math.max(0.45,fakieMul-(sp*fakieMul)/600);
  else fakieMul=Math.min(1,fakieMul+.012); // revenir regular pour reprendre de la vitesse
  sp*=fakieMul;
  bgDist+=sp;
  dist+=sp;score+=sp*.09;
  if(P.inv>0)P.inv--;
  if(P.wallCD>0)P.wallCD--;
  if(shake>0)shake--;
  sinceSpawn+=sp;
  // pas d'obstacles sur les premiers et derniers 100m (spawn a ~212px devant le joueur)
  if(sinceSpawn>=nextGap&&P.crash===0&&dist>790&&dist<LEVEL-480){spawn();sinceSpawn=0;nextGap=rnd(150,280)+speed*38;} // zone morte de fin ~48m (spawn a +21m devant : dernier obstacle ~27m avant la ligne)
  for(const o of obs){
    o.x-=sp;
    if(o.fly){o.x+=sp+2.4;o.fy+=o.vfy;o.vfy-=.22;o.rot+=o.vr;}
    if(o.duck>0)o.duck--;
    if(o.lidFly){ // couvercle ejecte : il spinne, retombe et disparait
      const L=o.lidFly;
      L.x-=sp-1.6;L.y+=L.vy;L.vy+=.22;L.rot+=.45;
      if(L.y>H+20)o.lidFly=null;
    }
    if(o.monFly){ // le monstre aussi, en vrille
      const M=o.monFly;
      M.x-=sp-1.1;M.y+=M.vy;M.vy+=.18;M.rot-=.3;
      if(M.y>H+20)o.monFly=null;
    }
  }
  obs=obs.filter(o=>o.x+o.w>-40&&(!o.fly||o.fy>-50));
  updateNPCs(sp);
  // train passager : contresens (vitesse ecran = defilement du monde + vitesse propre), 1 par partie
  if(train){
    train.x-=sp+TR_V*fakieMul;
    if(train.x+TR_W<-80)train=null;
  }else if(!trainDone&&dist>LEVEL*2/3&&dist<LEVEL-1300&&!obs.some(o=>o.k==='bridge'&&o.x<W+400&&o.x+o.w>-100)){ // dernier tiers du tableau, passage fini avant l'outro
    train={x:W+60,ridden:false};trainDone=true;
    tone('square',196,900,.5,.28);tone('square',147,900,.5,.24,.03); // klaxon deux tons au loin
  }
  if(demo&&P.crash===0)demoAI();
  if(P.crash>0){
    P.crash--;
    if(P.crash===0)P.inv=80;
  }else{
    // declenche le wall ride : fleche Haut (seule) quand on longe la grande FACE (parallele a la rue) d'un ledge/plateau
    if(!P.wall&&!P.grind&&KD.u&&!held&&P.wallCD<=0)for(const o of obs){
      if(o.k!=='stairs'&&o.k!=='wall')continue;
      const y0=(o.gy||GROUND)-o.h,len=o.topLen||o.w;
      if(P.x>o.x+1&&P.x<o.x+len-3&&P.y>y0+1){startWallride(o);break;} // sur la longueur de la face, sous le rebord
    }
    if(P.wall){
      const o=P.wall,y0=(o.gy||GROUND)-o.h,len=o.topLen||o.w;
      P.wallT++;
      // montee vive vers le plafond du ride (3/4 de la face), ride parallele tant que Haut est tenu ;
      // relache = redescente le long de la face (re-appui = remonte), decrochage en bas de mur
      const capY=(o.gy||GROUND)-((o.h*3/4)|0),lowY=GROUND-4,topY=y0;
      if(!KD.u&&P.wallBS)P.wallBS=0;                                // relacher Haut termine le boardslide (inertie puis redescente)
      if(P.wallBS){P.y=Math.max(topY,P.y-2.6);P.wallDir=0;P.wallCoast=12;} // boardslide : snap vif au sommet, verrouille sur l'arete
      else if(KD.u){P.y=Math.max(capY,P.y-1.8);P.wallDir=P.y>capY?-1:0;P.wallCoast=12;} // montee ~1.8 px/frame (re-armee l'inertie)
      else if(P.wallCoast>0){P.wallCoast--;P.wallDir=0;}            // inertie : ~12 frames de glisse a hauteur courante avant la descente
      else{P.y=Math.min(lowY,P.y+2.2);P.wallDir=1;}                 // descente ~2.2 px/frame (glisse, pas de chute)
      P.x+=(BASEX-P.x)*.06;             // reste centré : la face défile derriere le skater
      P.apex=P.takeoffY=y0;
      if(playT%4===0&&chain)chain.pts+=4; // riding tenu : goutte-a-goutte modere (les grinds font 5-11)
      // boardslides sur le mur : tap Droite = B/S, tap Gauche = F/S (bascule de stance, points au changement)
      if(pendR&&P.wallBS!==1){P.wallBS=1;addChainPts((P.fakie?'FAKIE ':'')+'B/S BOARDSLIDE',P.fakie?53:35);}
      else if(pendL&&P.wallBS!==-1){P.wallBS=-1;addChainPts((P.fakie?'FAKIE ':'')+'F/S BOARDSLIDE',P.fakie?53:35);}
      // pas d'etincelles sur le mur (reservees aux grinds de rail)
      // fin : bas du mur atteint en descente, bord de fuite depassé ou mur parti (Espace = kick-off dans pop())
      if(held||P.x>o.x+len-3||o.x+len<-4||(!KD.u&&P.y>=lowY)){
        P.wall=null;grindStop();P.air=true;P.vy=P.y<=lowY-6?2.2:1.2;P.popV=3;P.wallCD=16;P.wallBS=0; // chute franche depuis la hauteur, petit drop depuis le bas
        if(P.wallT>10)addChainPts('WALL RIDE',40);
      }
    }
    else if(P.grind){
      const r=P.grind;
      P.apex=P.takeoffY=P.y; // sur un rail : le niveau de reference est le rail
      // lean verrouille : la fleche fait passer 5-0 <-> grind <-> crooked (une etape par appui)
      if(pendR&&P.lean!==1){
        P.lean=P.lean===-1?0:1;
        pops.push({x:P.x,y:P.y-24,t:P.lean===0?'GRIND!':'CROOKED GRIND!',c:'#ff2975',l:30,s:1});
        sGrindHit();
      }
      if(pendL&&P.lean!==-1){
        P.lean=P.lean===1?0:-1;
        pops.push({x:P.x,y:P.y-24,t:P.lean===0?'GRIND!':'5-0 GRIND!',c:'#ff2975',l:30,s:1});
        sGrindHit();
      }
      // bas = descendre (petite fenetre de grace : si SPACE arrive juste apres, le trick de sortie gagne)
      if(lastDownF>grindStartF&&frame-lastDownF>=6){P.grind=null;P.lean=0;grindStop();P.air=true;P.vy=.5;P.airDown=KD.d;} // descendre : pas de re-accroche tant que Bas est tenu
      else if(r.k==='stairs'){
        const g=railGeom(r);
        if(P.x>g.x1){P.grind=null;P.lean=0;grindStop();P.air=true;P.vy=.6;}
        else{
          P.y=railYAt(g,P.x);
          if(playT%6===0&&chain)chain.pts+=P.lean?11:8;
          if(playT%2===0)parts.push({x:P.x+rnd(-7,-2),y:P.y+1,vx:rnd(-2,-.5),vy:rnd(-1.6,-.2),l:irnd(6,14),c:Math.random()<.5?'#ffffff':'#ffd319'});
        }
      }
      else if(P.x-4>r.x+r.w){P.grind=null;P.lean=0;grindStop();P.air=true;P.vy=.4;}
      else{
        P.y=(r.gy||GROUND)-r.h;
        if(playT%7===0&&chain)chain.pts+=P.lean?7:5;
        if(playT%3===0)parts.push({x:P.x+rnd(-7,-2),y:P.y+1,vx:rnd(-2,-.5),vy:rnd(-1.6,-.2),l:irnd(6,14),c:Math.random()<.5?'#ffffff':'#ffd319'});
      }
    }else if(P.air){
      P.apex=Math.min(P.apex,P.y); // point culminant du saut
      P.x+=(BASEX-P.x)*.04; // en l'air, retour doux vers la position habituelle
      // relacher gauche/droite en l'air prepare l'accroche : 5-0 (manual grind) / crooked (nose grind)
      if(upL&&!P.trick){P.aoll=-1;pops.push({x:P.x,y:P.y-30,t:'5-0 SET',c:'#00fff0',l:22,s:1});}
      else if(upR&&!P.trick){P.aoll=1;pops.push({x:P.x,y:P.y-30,t:'NOSE SET',c:'#00fff0',l:22,s:1});}
      P.vy+=(held&&P.vy<0)?.09:.16;
      if(P.vy>3.2)P.vy=3.2;
      const preY=P.y;
      P.y+=P.vy;
      if(P.trick){
        P.trick.t++;
        if(P.trick.t>=P.trick.dur){
          if(!chain)chain=newChain();
          chain.pts+=P.trick.pts;chain.cnt++;
          P.airTrickLbl=P.trick.label; // la fusion OVER BIG GAP se joue a l'atterrissage propre uniquement
          pops.push({x:P.x,y:P.y-26,t:P.trick.label+'!',c:'#00fff0',l:40,s:P.trick.name==='spin'&&P.spinCount>1?2:1});
          if(P.trick.name==='spin')applySpinFlip(); // clot ce demi-tour
          sTrickDone();P.trick=null;P.airTricked=true;
        }
      }
      // franchir un obstacle mou en l'air = bonus a l'atterrissage
      if(!P.wall&&trainTopAt(P.x)===null)for(const o of obs) // sur/au-dessus du toit du train : la rue est un autre plan, pas d'OVER
        if((o.k==='trash'||o.k==='barrier'||o.k==='hyd'||o.k==='bins')&&!o.fly&&!o.under&&P.x>o.x&&P.x<o.x+o.w){
          o.under=true;P.overCnt=(P.overCnt||0)+1;
        }
      // near-miss : froler un cone en l'air sans le toucher (style)
      for(const o of obs){
        if(o.nm||o.k!=='cone'||o.fly)continue;
        const og=o.gy||GROUND;
        if(P.x>o.x-2&&P.x<o.x+o.w+2&&P.y<og-3){o.nm=true;nearMiss(15,'NEAR MISS!');}
      }
      // atterrir sur le couvercle du monstre : il est ejecte, le skater rebondit
      if(P.vy>0)for(const o of obs){
        if(o.k!=='bins'||o.lidGone)continue;
        const bgy=o.gy||GROUND,peek=(Math.max(0,Math.sin(frame*.035+o.x*.07))*4)|0;
        const mx=o.x+15,lidY=bgy-24-peek;
        if(P.x+4>mx-1&&P.x-4<mx+11&&P.y>=lidY-2&&P.y<=lidY+5){
          o.lidGone=true;o.monGone=true;
          o.lidFly={x:mx-1,y:lidY,vy:-3.2,rot:0};
          o.monFly={x:mx+5,y:lidY+6,vy:-4.2,rot:0}; // le monstre est ejecte aussi
          P.vy=-2.4; // rebond
          addChainPts('LID BONK',25);
          tone('square',260,720,.15,.35);
          tone('sawtooth',500,180,.3,.3,.05); // cri du monstre
          shake=4;
          break;
        }
      }
      let caught=false;
      if(P.vy>0&&!P.wall)for(const o of obs){
        if(o.rail){
          const top=(o.gy||GROUND)-o.h;
          if(!(KD.d&&P.airDown)&&P.x+6>o.x&&P.x-6<o.x+o.w&&P.y>=top-4&&P.y<=top+10){
            settleTrick(); // trick encore en rotation : valide, puis on grind
            P.grind=o;grindStartF=frame;P.air=false;P.y=top;P.spinCount=0;
            P.lean=demo?dLean:(KD.r?1:(KD.l?-1:(P.aoll===-1?-1:(P.aoll===1?1:0))));P.aoll=0;
            if(!chain)chain=newChain();
            chain.cnt++;
            pops.push({x:P.x,y:P.y-24,t:(P.fakie?'FAKIE ':'')+(P.lean<0?'5-0 GRIND!':(P.lean>0?'CROOKED GRIND!':'GRIND!')),c:'#ff2975',l:35,s:1});
            sGrindHit();grindStart();awardOver();caught=true;break;
          }
        }else if(o.k==='barrier'&&!o.fly){
          // grind de barriere : fenetre serree, timing parfait requis
          const top=(o.gy||GROUND)-o.h;
          if(!(KD.d&&P.airDown)&&P.x+5>o.x&&P.x-5<o.x+o.w&&preY<=top+3&&P.y>=top-2){
            settleTrick();
            P.grind=o;P.lean=0;grindStartF=frame;P.air=false;P.y=top;P.spinCount=0;
            if(!chain)chain=newChain();
            chain.cnt++;chain.pts+=30;
            pops.push({x:P.x,y:P.y-24,t:'BARRIER GRIND!',c:'#ffd319',l:40,s:1});
            sGrindHit();grindStart();awardOver();caught=true;break;
          }
        }else if(o.k==='stairs'){
          const g=railGeom(o);
          if(!(KD.d&&P.airDown)&&P.x>=g.x0&&P.x<=g.x1){
            const ry=railYAt(g,P.x);
            if(P.y>=ry-4&&P.y<=ry+10){
              settleTrick();
              P.grind=o;grindStartF=frame;P.air=false;P.y=ry;P.spinCount=0;
              P.lean=demo?dLean:(KD.r?1:(KD.l?-1:(P.aoll===-1?-1:(P.aoll===1?1:0))));P.aoll=0;
              if(!chain)chain=newChain();
              chain.cnt++;
              pops.push({x:P.x,y:P.y-24,t:(P.fakie?'FAKIE ':'')+(P.lean<0?'5-0 GRIND!':(P.lean>0?'CROOKED GRIND!':'RAIL DOWN!')),c:'#00fff0',l:38,s:1});
              sGrindHit();grindStart();awardOver();caught=true;break;
            }
          }
        }
      }
      if(caught)bgPend=false; // accroche un grind : pas un atterrissage curb-a-curb, la fusion tombe
      if(!caught&&P.air){
        const gy=landY(P.x,preY);
        if(P.y>=gy){
          P.y=gy;
          if(P.trick){ // trick non fini a l'atterrissage : on le valide, pas de bail
            if(!chain)chain=newChain();
            chain.pts+=P.trick.pts;chain.cnt++;
            P.airTrickLbl=P.trick.label;
            if(P.trick.name==='spin')applySpinFlip();
            P.trick=null;P.airTricked=true;sTrickDone();
          }
          if(bgPend){bgPend=false;if(gy>=GROUND-1)bigGapAward(P.airTrickLbl);} // fusion si reception propre au niveau rue
          if(train&&!train.ridden&&P.y<GROUND-24&&trainTopAt(P.x)!==null&&Math.abs(trainTopAt(P.x)-P.y)<2){
            train.ridden=true;addChainPts('TRAIN RIDE',60);shake=2; // atterrir sur le toit du train (1 fois par train)
          }
          P.air=false;sLand();awardOver();
          // au sol : on ne repart en manual QUE pour un 180-depuis-manual (relandMan). Un ollie simple = fin du manual.
          if(P.relandMan){if(P.aoll===-1)startManual(false);else if(P.aoll===1)startManual(true);}
          P.aoll=0;P.spinCount=0;
          for(let i=0;i<5;i++)parts.push({x:P.x+rnd(-5,5),y:gy,vx:rnd(-1,-.2),vy:rnd(-.8,-.1),l:irnd(8,16),c:'#6b5aa0'});
        }
      }
    }else{
      const ttv=trainTopAt(P.x);
      if(ttv!==null&&P.y<GROUND-24&&Math.abs(ttv-P.y)<=6){
        if(ttv<P.y-.5){P.y=ttv;P.apex=P.takeoffY=P.y;P.trainRamp=true;} // rampe montante : on la remonte (kicker arme)
        else if(P.trainRamp&&ttv<=GROUND-TR_H+1){P.trainRamp=false;jump(-1.3);P.takeoffY=GROUND-TR_H;} // sommet de rampe = micro-saut auto (vrai air, moitie du petit saut)
        else{P.y=ttv;P.apex=P.takeoffY=P.y;P.trainRamp=false;} // toit plat / rampe descendante : suit le profil
      }else if(P.trainRamp)P.trainRamp=false;
      else{
      const gy=groundAt(P.x,P.y);
      if(gy>P.y+.5){P.jumpFromY=P.y;P.air=true;P.vy=0;P.man=0;}
      else{P.y=gy;P.apex=P.takeoffY=P.y;} // au sol : le niveau de reference suit le sol
      }
      if(!P.air){
        if(P.slide>0){
          P.slide--;
          if(playT%2===0)parts.push({x:P.x+rnd(-8,0),y:GROUND,vx:rnd(-1.6,-.4),vy:rnd(-1.2,-.2),l:irnd(8,18),c:'#6b5aa0'});
        }
        if(P.rev>0)P.rev--;
        if(P.man){ // manual / nose manual : duree fixe ~3s (180 frames), pas de balance
          P.man++;
          if(P.man>120)P.man=0; // fin apres 2s (un saut le termine via jump())
          else if(playT%5===0&&chain)chain.pts+=2;
        }
        // crouch : bas tenu seulement (le manual demarre au keyup gauche/droite)
        P.crouch=(KD.d&&!P.man)?P.crouch+1:0;
        // encaissement du combo : gere par la jauge de lien (bloc unique en fin de frame)
        // dynamique de poussee : le skater oscille autour de sa position selon la phase
        if(P.man||P.crouch>0||P.fakie){
          if(P.pushT%150<42)P.pushT=42; // pas de poussee pendant manual / crouch / en fakie
          P.x+=(BASEX-P.x)*.08;
        }else P.x+=(BASEX+pushOffset(P.pushT%150)-P.x)*.3;
      }
      P.pushT++;
      if((P.man||P.crouch>0||P.fakie)&&P.pushT%150<42)P.pushT=42; // jamais de frame de poussee dans ces etats
    }
    if(P.inv===0&&P.crash===0&&state==='play'){
      const pl=P.x-5,pr=P.x+5,pt=P.y-19,pb=P.y;
      for(const o of obs){
        // rails et ledges : le skater passe devant, on peut sauter dessus a tout moment
        if(o.k==='trash'||o.k==='barrier'){
          // obstacle mou : pas de bail, il valse
          const og=o.gy||GROUND;
          if(!o.fly&&pr>o.x&&pl<o.x+o.w&&pb>og-o.h&&pb<=og+2){
            o.fly=true;o.fy=0;o.vfy=2.6;o.rot=0;o.vr=.22+Math.random()*.2;
            shake=4;
            tone('square',160,70,.18,.35);noiseHit(.12,.25,800,'lowpass');
            for(let i=0;i<8;i++)parts.push({x:o.x+o.w/2,y:og-o.h/2,vx:rnd(-1,2),vy:rnd(-2.2,-.5),l:irnd(10,20),c:'#b9c2e8'});
          }
        }
        // bornes d'incendie : element de decor, on passe devant
      }
      // la bordure de l'autre cote de l'intersection : il faut sauter pour remonter
      const cb=crossEndScreen(dist+(P.x-BASEX));
      if(cb>-999&&pr>cb&&pl<cb+3&&pb>GROUND+2){wipeout();}
    }
    // ---- COMBO / LINE : paliers de jus + jauge de lien (gestion unique par frame, hors crash) ----
    if(chain){
      if(chain.cnt>chain.best){ // paliers atteints (une seule fois par line)
        const prev=chain.best;chain.best=chain.cnt;
        if(prev<5&&chain.cnt>=5){pops.push({x:P.x,y:P.y-40,t:'SICK LINE!',c:'#ffd319',l:45,s:2});tone('square',880,1320,.1,.3);tone('square',1320,1760,.12,.3,.09);}
        else if(prev<8&&chain.cnt>=8){pops.push({x:P.x,y:P.y-40,t:'INSANE!',c:'#ff2975',l:50,s:2});tone('square',1046,1568,.12,.32);tone('square',1568,2093,.14,.32,.1);shake=Math.max(shake,3);}
      }
      if(P.air||P.grind||P.wall||P.man>0||P.slide>0||P.rev>0||(train&&P.y<GROUND-24&&trainTopAt(P.x)!==null)){
        chain.link=chain.linkMax;      // gele a plein tant qu'un element est actif
      }else{
        chain.link--;                  // roulage neutre au sol : la fenetre se ferme
        if(chain.link<=0)landChain();   // a vide : encaissement automatique
      }
    }
  }
  // BIG GAP : franchir toute l'intersection en l'air (ollie charge, bien time) sans toucher le fond
  const pwg=dist+(P.x-BASEX),gi=Math.floor(pwg/CROSSPER),gpz=pwg-gi*CROSSPER;
  if(gi>=1&&gpz<CROSSLEN){ // dans le gap
    if(gapIdx!==gi){gapIdx=gi;gapTouched=false;}
    if(!P.air&&P.y>=GROUND+CROSSDROP-1&&gpz>10&&gpz<CROSSLEN-10)gapTouched=true; // roue posee au fond (hors bords)
  }else if(gapIdx===gi&&gi>=1){ // vient de sortir du gap
    if(!gapTouched){
      // curb a curb uniquement : saut parti du niveau rue, ni grind, ni wall, ni traversee posee sur le pont
      const clean=!P.grind&&!P.wall&&(P.air||P.y>=GROUND-1)&&P.jumpFromY>=GROUND-2;
      if(clean){
        if(P.trick||P.airTrickLbl){ // air trick pendant le saut : fusion, resolue a l'atterrissage propre
          if(P.air)bgPend=true;else bigGapAward(P.airTrickLbl);
        }else bigGapAward(null);    // gap sec : BIG GAP classique
      } // sinon (pont, grind, wall ride...) : rien du tout
    }
    gapIdx=-1;
  }
  for(const p of parts){p.x+=p.vx;p.y+=p.vy;p.vy+=.06;p.l--;}
  parts=parts.filter(p=>p.l>0);
  for(const p of pops){p.y-=.5;p.l--;}
  pops=pops.filter(p=>p.l>0);
}
//============================================================ DRAWING
function drawSun(){
  const cx=246,cy=60,r=27;
  for(let iy=cy-r;iy<=cy+r;iy++){
    const bd=cy+r-iy;
    if(bd<=18&&SUNCUT.has(bd))continue;
    const dy=iy-cy,hw=Math.sqrt(r*r-dy*dy)|0;
    px(cx-hw,iy,hw*2,1,mix('#ffe45e','#ff2975',(dy+r)/(2*r)));
  }
}
function drawBuildings(B,base,shade,winA,winB,par){
  const s=bgDist*par%B.L;
  for(const b of B.list){
    let bx=b.x-s;
    if(bx<-b.w)bx+=B.L;
    if(bx>W)continue;
    px(bx,base-b.h,b.w,b.h,shade);
    for(const wn of b.wins)px(bx+wn[0],base-b.h+wn[1],1,2,wn[2]?winB:winA);
  }
}
function drawPalm(x,base,h){
  for(let i=0;i<h;i++)px(x+Math.round(i*.22),base-i,2,1,'#1e0f3f');
  const tx=x+Math.round(h*.22)+1,ty=base-h;
  const dirs=[[-1,-.25],[-.85,-.7],[-.35,-1],[.35,-1],[.85,-.7],[1,-.25]];
  for(const dd of dirs)for(let j=1;j<=5;j++)
    px(tx+dd[0]*j,ty+dd[1]*j+j*j*.14,2,1,'#1e0f3f');
}
function drawObs(o){
  const gy=o.gy||GROUND;
  if(o.fly){
    ctx.save();
    ctx.translate(o.x+o.w/2,gy-o.h/2-o.fy);
    ctx.rotate(o.rot);
    ctx.translate(-(o.x+o.w/2),-(gy-o.h/2));
  }
  if(o.rail){
    const top=gy-o.h;
    px(o.x+2,top+2,2,o.h-2,'#5b6390');
    px(o.x+o.w-4,top+2,2,o.h-2,'#5b6390');
    if(o.w>90)px(o.x+o.w/2-1,top+2,2,o.h-2,'#5b6390');
    px(o.x,top,o.w,2,'#dfe6ff');px(o.x,top,o.w,1,'#ffffff');
  }else if(o.k==='wall'){
    // long mur de rue (façade béton + graffiti néon) : surface de wall ride, parallele a la rue
    const y0=gy-o.h;
    px(o.x,y0,o.w,o.h,'#241a3f');                 // corps du mur
    px(o.x,y0,o.w,1,'#6a5aa8');                    // arete haute
    px(o.x,y0+1,o.w,1,'#3a2c66');
    px(o.x,y0,1,o.h,'#161028');px(o.x+o.w-1,y0,1,o.h,'#161028'); // bords
    for(let jy=y0+9;jy<gy-2;jy+=9)px(o.x+1,jy,o.w-2,1,'#1b1338');   // rangs de blocs
    for(let jx=o.x+22;jx<o.x+o.w-4;jx+=44)px(jx,y0+2,1,o.h-3,'#1b1338'); // joints verticaux
    // graffitis néon repartis le long du mur
    for(let gx=o.x+34;gx<o.x+o.w-40;gx+=150){
      const c=((gx/150|0)&1)?'#ff2975':'#00fff0';
      px(gx,y0+12,22,3,c);px(gx+4,y0+9,3,9,c);px(gx+15,y0+15,5,10,c);
      px(gx+8,y0+22,10,2,c==='#ff2975'?'#00fff0':'#ffd319');
    }
    px(o.x,gy-1,o.w,1,'#0f0a1e');                  // pied du mur
  }else if(o.k==='bridge'){
    // viaduc Meatpacking : long tablier acier/brique sur piliers a arches, drop au bout
    const y0=gy-o.h,te=o.x+o.w,deckH=11;
    for(let cxx=o.x+4;cxx<te-6;cxx+=32){          // piliers + arches
      px(cxx,y0+deckH,5,gy-(y0+deckH),'#4a2f2a');
      px(cxx,y0+deckH,1,gy-(y0+deckH),'#6a423a');
      for(let a=1;a<=6;a++)px(cxx+5+a,y0+deckH+a*a*.5,1,1,'#2a1815');
    }
    px(o.x,y0,o.w,deckH,'#4a2f2a');               // tablier brique
    px(o.x,y0,o.w,1,'#c98a5a');
    px(o.x,y0+2,o.w,1,'#331d1a');
    px(o.x,y0+deckH-1,o.w,1,'#9a9aa8');            // poutre acier
    px(o.x,y0-1,o.w,1,'#7a5548');                  // bord du tablier
    px(te-2,y0-2,2,deckH+2,'#c9c2d0');            // bord de fin (drop)
    px(o.x,y0-2,2,deckH+2,'#7a5548');
  }else if(o.k==='stairs'){
    const y0=gy-o.h,te=o.x+o.topLen,sw=o.stairLen/o.steps;
    px(o.x,y0,o.topLen,o.h,'#3a2f63');
    px(o.x,y0,o.topLen,1,'#a393dd');
    px(o.x,y0+1,o.topLen,1,'#5c4d94');
    px(o.x,y0,2,o.h,'#1b1338');
    for(let jx=o.x+34;jx<te-4;jx+=44)px(jx,y0+2,1,o.h-2,'#241b48'); // joints de dalles
    for(let i=0;i<o.steps;i++){
      const ty=y0+(i+1)*(o.h/o.steps),txx=te+i*sw;
      px(txx,ty,sw,gy-ty,'#3a2f63');
      px(txx,ty,sw,1,'#a393dd');
      px(txx,ty,1,gy-ty,'#1b1338');
    }
    const g=railGeom(o),n=(g.x1-g.x0)|0;
    for(const pxp of[g.x0+4,te+o.stairLen*.5,g.x1-3])
      px(pxp,railYAt(g,pxp)+2,2,groundAt(pxp)-railYAt(g,pxp)-2,'#5b6390');
    for(let i=0;i<=n;i++)px(g.x0+i,g.y0+(g.y1-g.y0)*i/n,1,2,'#dfe6ff');
    px(g.x0,g.y0,3,1,'#ffffff');
  }else if(o.k==='cone'){
    px(o.x+4,gy-9,2,2,'#ff7f11');px(o.x+3,gy-7,4,2,'#ffffff');
    px(o.x+2,gy-5,6,3,'#ff7f11');px(o.x,gy-2,10,2,'#ff9d3f');
  }else if(o.k==='hyd'){
    px(o.x+2,gy-12,4,2,'#ff5d7e');px(o.x+1,gy-10,6,8,'#ff3355');
    px(o.x,gy-8,8,2,'#ff3355');px(o.x+5,gy-10,2,8,'#c22646');px(o.x+2,gy-2,4,2,'#b31742');
  }else if(o.k==='bins'){
    if(!o.monGone){
      // monstre bleu gourmand dans la poubelle de droite
      const peek=(Math.max(0,Math.sin(frame*.035+o.x*.07))*4)|0;
      const mx=o.x+15,my=gy-19-peek;
      px(mx,my,10,8,'#2f7ce0');                                  // tete poilue
      px(mx-1,my+2,1,2,'#2f7ce0');px(mx+10,my+3,1,2,'#2f7ce0');  // touffes
      px(mx+1,my-3,3,4,'#ffffff');px(mx+6,my-3,3,4,'#ffffff');   // yeux globuleux
      px(mx+2+((frame>>4)&1),my-2,1,2,'#140b20');
      px(mx+6+((frame>>5)&1),my-1,1,2,'#140b20');                // pupilles folles
      px(mx+2,my+5,7,3,'#10203a');                               // grande bouche
      px(mx+11,my+1,4,3,'#b5793e');px(mx+12,my+2,1,1,'#5c3620');px(mx+14,my+1,1,1,'#5c3620'); // cookie
      if(!o.lidGone)px(mx-1,my-5,12,2,'#7fb6c9');                 // couvercle en chapeau
    }
    if(o.lidFly){                                               // couvercle ejecte en vrille
      ctx.save();ctx.translate(o.lidFly.x+6,o.lidFly.y);ctx.rotate(o.lidFly.rot);
      px(-6,-1,12,2,'#7fb6c9');px(-2,-2,4,1,'#a8d8e8');
      ctx.restore();
    }
    if(o.monFly){                                               // le monstre ejecte, bras en l'air
      ctx.save();ctx.translate(o.monFly.x,o.monFly.y);ctx.rotate(o.monFly.rot);
      px(-5,-4,10,8,'#2f7ce0');
      px(-7,-2,2,2,'#2f7ce0');px(5,-3,2,2,'#2f7ce0');           // bras ecartes
      px(-4,-7,3,4,'#ffffff');px(1,-7,3,4,'#ffffff');
      px(-3,-6,1,2,'#140b20');px(2,-5,1,2,'#140b20');
      px(-3,1,7,3,'#10203a');                                   // bouche grande ouverte
      px(6,-6,4,3,'#b5793e');                                   // le cookie s'envole avec lui
      ctx.restore();
    }
    for(const bx of[o.x,o.x+14]){                               // les deux poubelles devant
      px(bx,gy-13,12,2,'#7fb6c9');
      px(bx+1,gy-11,10,11,'#3f7f8f');
      px(bx+3,gy-11,1,11,'#356b78');px(bx+7,gy-11,1,11,'#356b78');
    }
  }else if(o.k==='trash'){
    px(o.x+5,gy-15,2,2,'#7fb6c9');px(o.x,gy-13,12,2,'#7fb6c9');
    px(o.x+1,gy-11,10,11,'#3f7f8f');px(o.x+3,gy-11,1,11,'#356b78');px(o.x+7,gy-11,1,11,'#356b78');
  }else{
    px(o.x+2,gy-6,2,6,'#aab');px(o.x+18,gy-6,2,6,'#aab');
    px(o.x,gy-10,22,4,'#eeeeee');
    for(let i=0;i<4;i++)px(o.x+1+i*6,gy-10,3,4,'#ff2975');
  }
  if(o.fly)ctx.restore();
}
// logo Boutique Adrenaline : deux etoiles (noire sur blanc / blanche sur noir)
const STAR=[
"......X......",
".....XXX.....",
".....XXX.....",
"XXXXXXXXXXXXX",
".XXXXXXXXXXX.",
"..XXXXXXXXX..",
"...XXXXXXX...",
"..XXXXXXXXX..",
"..XXXX.XXXX..",
".XXX.....XXX.",
".XX.......XX."];
function drawStar(x0,y0,c,s=1){
  for(let r=0;r<STAR.length;r++)for(let k=0;k<13;k++)
    if(STAR[r][k]==='X')px(x0+k*s,y0+r*s,s,s,c);
}
function drawLogo(cx,y,s=1){
  const tw=17*s,th=15*s,x0=(cx-tw)|0;
  px(x0-s,y-s,tw*2+2*s,th+2*s,'#8a78c9');
  px(x0,y,tw,th,'#ffffff');
  px(x0+tw,y,tw,th,'#140b20');
  drawStar(x0+2*s,y+2*s,'#140b20',s);
  drawStar(x0+tw+2*s,y+2*s,'#ffffff',s);
}
function drawSplash(){ // ecran studio, style arcade
  splashT++;
  ctx.fillStyle='#05010f';ctx.fillRect(0,0,W,H);
  if(splashT>30)drawLogo(W/2,42,2);
  if(splashT>70)textCSh('BOUTIQUE ADRENALINE',W/2,96,'#ffffff','#3a1030',2);
  if(splashT>100)textCSh('PRESENTS',W/2,120,'#9f8fd0','#221144');
  if(splashT>150&&(frame/26|0)%2)textCSh('EST. MMXXVI',W/2,150,'#584a85','#0a0518');
  if(splashT>240)state='title';
}
function drawFinish(fx){
  for(let r=0;r<22;r++)for(let c=0;c<2;c++)
    px(fx+c*2,GROUND-44+r*2,2,2,(r+c)%2?'#ffffff':'#140b20');
  px(fx+4,GROUND-44,9,4,'#ff2975');
  px(fx+4,GROUND-40,6,2,'#ff2975');
}
function drawBoard(cx,cy,ang){
  ctx.save();ctx.translate(cx|0,cy|0);if(ang)ctx.rotate(ang);
  px(-8,-2,16,1,C.grip);
  px(-8,-1,16,2,C.deck);
  px(-8,-3,1,2,C.grip);px(7,-3,1,2,C.grip);
  px(-6,1,3,2,C.wheel);px(3,1,3,2,C.wheel);
  ctx.restore();
}
function drawBoardWall(cx,cy){ // wall ride : planche verticale plaquee au mur, on voit le DESSUS (grip), roues cachees cote mur
  px(cx-2,cy-8,4,16,C.grip);      // face grip (dessus) visible, pleine hauteur
  px(cx-2,cy-8,4,1,C.deck);       // nose arrondi (bois)
  px(cx-2,cy+7,4,1,C.deck);       // tail arrondi
  px(cx-3,cy-6,1,12,C.deck);      // tranche du deck cote skater
  px(cx-1,cy-6,1,3,'#ffffff');    // petit reflet neon sur le grip
}
function drawBoardSlide(cx,cy,bs){ // boardslide en PLONGEE : deck rouge plein face camera (pas de roues), skater vu de dessus penche sur le vide
  const fw=bs<0?1:-1; // regard : F/S face a la direction (droite), B/S dos a la direction (gauche)
  ctx.save();ctx.translate(cx|0,cy|0);ctx.rotate(bs*.18); // legere inclinaison opposee B/S <-> F/S
  // planche : DESSUS entierement rouge (couleur deck de la marque), perpendiculaire au deplacement, a cheval sur l'arete
  px(-3,-9,6,18,'#140b20');                        // contour epais
  px(-2,-8,4,16,C.deck);                           // deck rouge plein — pas de grip, pas de bande blanche
  // pieds ecartes largeur d'epaules, un a l'avant / un a l'arriere de la planche (stance sur le grip)
  px(-2,-7,4,2,'#140b20');px(-2,5,4,2,'#140b20');  // contours chaussures
  px(-1,-7,2,2,'#ffffff');px(-1,5,2,2,'#ffffff');
  // jambes tres raccourcies par la plongee (les pieds sont le plus loin de la camera)
  px(-1,-5,2,1,'#4a4460');px(-1,4,2,1,'#4a4460');
  // buste : epaules paralleles a la planche (axe vertical), bras ouverts dans l'axe du deplacement
  px(-3,-5,6,10,'#140b20');                        // contour buste (separe le skater de la planche rouge)
  px(-2,-4,4,8,'#c21b57');                         // dos du t-shirt vu de dessus (nuance ombre : lisible sur le deck)
  px(-6,-2,3,2,'#c21b57');px(3,-2,3,2,'#c21b57');  // manches tendues (equilibre)
  px(-7,-2,1,2,'#ffcf9f');px(6,-2,1,2,'#ffcf9f');  // mains
  // tete au premier plan (la plus proche de la camera) : dessus du crane, plus large que le corps
  px(-3,-3,7,6,'#140b20');                         // contour tete
  px(-2,-2,5,4,'#2fd44f');                         // cheveux vus de dessus
  px(-2,-2,3,1,'#9dff6a');                         // reflet
  px(fw>0?3:-3,-1,1,2,'#ffcf9f');                  // bout du visage qui depasse cote regard (F/S avant, B/S arriere)
  ctx.restore();
}
function drawBoardWallTop(cx,cy,ang){ // wall ride : dessus de planche face camera, orientee dans le sens du deplacement
  ctx.save();ctx.translate(cx|0,cy|0);if(ang)ctx.rotate(ang);
  px(-8,-2,16,4,C.grip);                    // face grip pleine (planche plaquee au mur, roues cachees)
  px(-8,-2,1,4,C.deck);px(7,-2,1,4,C.deck); // nose / tail arrondis (bois)
  px(-6,-3,12,1,C.deck);                    // tranche du deck cote haut
  px(-5,-1,3,1,'#ffffff');                  // reflet neon sur le grip
  ctx.restore();
}
function drawBoardShuv(cx,cy,pr){ // rotation 180 horizontale : profil - intermediaire - trucks - intermediaire - profil
  const ph=pr<.15?0:pr<.35?1:pr<.65?2:pr<.85?1:0;
  if(ph===0){drawBoard(cx,cy,0);return;}
  ctx.save();ctx.translate(cx|0,cy|0);
  if(ph===1){ // vue intermediaire : planche raccourcie
    px(-5,-2,10,1,C.grip);
    px(-5,-1,10,2,C.deck);
    px(-4,1,3,2,C.wheel);px(1,1,3,2,C.wheel);
  }else{ // vue de bout : trucks arriere
    px(-2,-3,4,2,C.deck);
    px(-2,-1,4,1,'#8a1140');
    px(-1,0,2,2,'#3a3a55');
    px(-3,0,2,3,C.wheel);px(1,0,2,3,C.wheel);
  }
  ctx.restore();
}
const PAL={K:'#140b20',H:'#2fd44f',h:'#9dff6a',S:'#ffcf9f',s:'#d89a6a',
           T:'#ff2975',t:'#c21b57',P:'#4a4460',p:'#37324a',W:'#ffffff',w:'#b9c2e8'};
const SPRITES={
roll:[
"..K...K...K.",
".KHK.KHK.KHK",
".KHHHHHHHHK.",
".KHHhSSSK...",
"..KHSSKSK...",
"...KsSSSK...",
"....KSSK....",
"..KTTTTTK...",
".KSTTTTTTSK.",
"KSKTTTtTTKSK",
"...KTTtTK...",
"..KPPPPPPK..",
"..KPPppPPK..",
".KPPK..KPPK.",
".KPK...KPK..",
".KSK...KSK..",
"KWWK...KWWK.",
"KwWK...KwWK."],
air:[
"..K...K...K.",
".KHK.KHK.KHK",
".KHHHHHHHHK.",
".KHHhSSSK...",
"..KHSSKSK...",
"...KsSSSK...",
".KSKKSSKKSK.",
"..KKTTTTKK..",
"...KTTTTK...",
"...KTTtTK...",
"..KPPPPPPK..",
"..KPPppPPK..",
".KPPK..KPPK.",
".KSK....KSK.",
".KWWK..KWWK.",
".KwWK..KwWK."],
grab:[
"..K...K...K.",
".KHK.KHK.KHK",
".KHHHHHHHHK.",
".KHHhSSSK...",
"..KHSSKSK...",
"...KsSSSK...",
".KSKKSSK....",
"..KKTTTTK...",
"...KTTTTKK..",
"...KTTtTKSK.",
"...KPPPPKSK.",
"..KPPppPPK..",
".KPPK..KPPK.",
".KSK....KSK.",
".KWWK..KWWK.",
".KwWK..KwWK."],
pushB:[
"............",
"...K...K....",
"..KHK..KHK..",
"...KHHHHHHK.",
"..KHHhSSSK..",
"...KHSSKSK..",
"....KsSSSK..",
".....KSSK...",
"....KTTTK...",
"....KTTTKSK.",
"....KTtTK...",
"...KPPPPK...",
"...KPPpPK...",
"...KPPK.KPK.",
"....KSK.KSK.",
"....KSK.KSK.",
"....KSKKWWK.",
"....KSKKwWK.",
"....KSK.....",
"....KSK.....",
"....KSK.....",
"...KWWK.....",
"...KwWK....."],
pushC:[
"............",
"...K...K....",
"..KHK..KHK..",
"...KHHHHHHK.",
"..KHHhSSSK..",
"...KHSSKSK..",
"....KsSSSK..",
".....KSSK...",
"....KTTTK...",
"....KTTTKSK.",
"....KTtTK...",
"...KPPPPK...",
"...KPPpPK...",
"...KPPK.KPK.",
"...KSK..KSK.",
"..KSK...KSK.",
".KSK...KWWK.",
".KSK...KwWK.",
".KSK........",
"KSK.........",
"KWWK........",
"KwWK........",
"............"],
pushD:[
"............",
"...K...K....",
"..KHK..KHK..",
"...KHHHHHHK.",
"..KHHhSSSK..",
"...KHSSKSK..",
"....KsSSSK..",
".....KSSK...",
"....KTTTK...",
".KwWKTTTKSK.",
".KWWKTtTK...",
"..KSKPPPPK..",
"..KSKPPpPK..",
".KPPPK..KPK.",
"........KSK.",
"........KSK.",
".......KWWK.",
".......KwWK.",
"............",
"............",
"............",
"............",
"............"],
grind:[
"..K...K...K.",
".KHK.KHK.KHK",
".KHHHHHHHHK.",
".KHHhSSSK...",
"..KHSSKSK...",
"...KsSSSK...",
"..KTTTTTK...",
".KSTTTtTTSK.",
"KSK.KTTK.KSK",
"..KPPPPPPK..",
"..KPPppPPK..",
".KPPK..KPPK.",
".KWWK..KWWK.",
".KwWK..KwWK."]
};
//============================================================ NPC (decor vivant)
const NPCPAL={K:'#140b20',S:'#e8b487',s:'#c08a5c',H:'#241736',C:'#7a4a2e',P:'#2e3350',
              W:'#ddd8f0',D:'#8a5a3b',T:'#00e0d0',R:'#ff2975',B:'#7a1f35',G:'#3a3550',
              g:'#28243c',Y:'#ffd319',b:'#54c8ff',O:'#ffffff',M:'#4fd8e8'};
const NPCS={
manA:["..KKKK....",".KHHHHK...",".KHHHHK...",".KSKSSK...",".KsSSSK...","..KSSK....",".KCCCCK...","KCCCCCCK..","KCCCCCCK..","KCCCCCCK..","KSKCCCCK..",".KCCCCK...",".KPPPPK...",".KPPPPK...",".KPPPPK...","KPPK..KPK.","KPK....KPK","KWWK..KWWK"],
manB:["..KKKK....",".KHHHHK...",".KHHHHK...",".KSKSSK...",".KsSSSK...","..KSSK....",".KCCCCK...","KCCCCCCK..","KCCCCCCK..","KCCCCCCK..","KSKCCCCK..",".KCCCCK...",".KPPPPK...",".KPPPPK...",".KPPPPK...","...KPPK...","...KPPK...","..KWWKWW.."],
dogA:[".KK.....K","KDDK...KK","KDDDDDDDK",".KD...KD.",".KK...KK."],
dogB:[".KK.....K","KDDK...KK","KDDDDDDDK","..KD..KD.","..KK..KK."],
jogA:["...KKKK...","..KYYYYK..","..KYYYYK..",".YKSSKSK..","YYKSSSSK..","..KSSSK...","...KSK....","..KTTTTK..",".KTTTTTTK.",".KTTTTTTK.",".KSKTTKSK.","..KTTTTK..","..KRRRRK..","..KRRRRK..","..KRKKRK..",".KSK..KSK.",".KSK..KSK.",".KWWK..KWW"],
jogB:["...KKKK...","..KYYYYK..","..KYYYYK..",".YKSSKSK..","YYKSSSSK..","..KSSSK...","...KSK....","..KTTTTK..",".KTTTTTTK.",".KTTTTTTK.",".KSKTTKSK.","..KTTTTK..","..KRRRRK..","..KRRRRK..","...KRKR...","..KSKKS...","..KSK.KS..","..KWK.KW.."],
gang:[".KKKKK...","KBBBBBK..","KBBBBBK..","KSKKKSK..",".KSSSK...",".KsSsK...",".KGGGK...","KGGGGGK..","KGGGGGK..","KGsSsGK..","KGGGGGK..",".KGGGK...",".KPPPK...",".KPPPK...","KPK.KPK..","KPK.KPK..","KWWKKWWK."],
// kid en trottinette (contresens, danger), taille du skater : guidon en T a l'avant (gauche)
kidA:[".....KKKK....","....KYYYYK...","....KYYYYK...","....KSSSSK...","....KSKSSK...",".....KSSK....","MMMM.KSSK....","..M..KTTTK...","..M.KKTTTTK..","..M..KTTTTK..","..M..KTTTK...","..M..KPPPK...","..M..KPKKP...","..M..KWK.KW..","..MMMKK..K...","MMMMMMMMMMMM.",".OO....OO....",".OO....OO...."],
kidB:[".....KKKK....","....KYYYYK...","....KYYYYK...","....KSSSSK...","....KSKSSK...",".....KSSK....","MMMM.KSSK....","..M..KTTTK...","..M.KKTTTTK..","..M..KTTTTK..","..M..KTTTK...","..M..KPPPK...","..M..KPKKP...","..M..KWKKW...","..MMMKKK.K...","MMMMMMMMMMMM.",".OO....OO....",".OO....OO...."],
// kid qui pleure apres le crash (assis, mains au visage, larmes)
kidCry:["....KKKK....","...KYYYYK...","...KYYYYK...","...KSbSbK...","...KSSSSK...","...KKKKKK...","..KKTTTTKK..",".KTTTTTTTTK.",".KTTTTTTTTK.",".KPPPPPPPPK.","..KWK..KWK..","..KWK..KWK.."]
};
let npcs=[],npcT=180,npcSaid={};
const NPCLINES={ // repertoire de repliques, choisies au hasard (2 par personnage par partie)
  jog:[
    ['HEY! WATCH WHERE','YOU ARE GOING'],
    ['ON YOUR LEFT!'],
    ['NICE MOVES, KID'],
    ['OUT OF MY WAY!'],
    ['IS THAT A','GREEN MOHAWK?'],
    ['CARDIO, BABY!'],
    ['YOU CALL THAT','EXERCISE?']
  ],
  dogman:[
    ['YOU LITTLE PUNK!'],
    ['SLOW DOWN,','MANIAC!'],
    ['REX, DON\'T LOOK'],
    ['KIDS THESE DAYS...'],
    ['GET A JOB!'],
    ['MY DOG SKATES','BETTER THAN YOU'],
    ['THE SIDEWALK IS','FOR EVERYONE!']
  ]
};
function drawMap(m,x,feetY){
  const h=m.length,w=m[0].length,x0=(x-w/2)|0,y0=(feetY|0)-h+1;
  for(let r=0;r<h;r++)for(let c=0;c<w;c++){
    const ch=m[r][c];
    if(ch!=='.')px(x0+c,y0+r,1,1,NPCPAL[ch]||'#fff');
  }
}
function drawNPC(n){
  const y=GROUND;
  if(n.k==='dogman'){
    drawMap(NPCS.manA,n.x,y);          // immobile : pose fixe (pas d'animation de marche)
    drawMap(NPCS.dogA,n.x-16,y);
    px(n.x-6,y-7,1,1,'#5c4d94');px(n.x-9,y-6,2,1,'#5c4d94');px(n.x-13,y-5,2,1,'#5c4d94'); // laisse
  }else if(n.k==='jog'){
    drawMap((n.f>>3)&1?NPCS.jogB:NPCS.jogA,n.x,y); // court vers la droite
  }else if(n.k==='scooter'){
    if(n.cry>0){ // apres le crash : assis par terre, il pleure
      drawMap(NPCS.kidCry,n.x,y);
      if((frame>>3)&1){px(n.x-4,y-8,1,3,'#54c8ff');px(n.x+4,y-8,1,3,'#54c8ff');} // larmes qui jaillissent
      if((frame>>4)&1)textCSh('WAAAH!',n.x,y-26,'#54c8ff','#0a2540');
    }else{
      drawMap((n.f>>3)&1?NPCS.kidB:NPCS.kidA,n.x,y); // fonce a contresens, guidon deja dans le sprite
    }
  }else{ // gang : trois silhouettes
    for(let i=0;i<3;i++){
      const bob=((frame>>4)+i)&1;
      drawMap(NPCS.gang,n.x+i*11,y-bob);
      if(i===1)px(n.x+i*11-3,y-16+bob,7,2,'#8a1f4f'); // bonnet different pour celui du milieu
    }
  }
}
function drawBubble(n){
  const lines=n.sayLines||[' '],cx=n.x;
  const bw=Math.max(...lines.map(l=>textW(l)))+6,bh=lines.length*7+4;
  let bx=(cx-bw/2)|0;bx=Math.max(2,Math.min(W-bw-2,bx));
  const by=GROUND-24-bh-5;
  px(bx-1,by-1,bw+2,bh+2,'#140b20');
  px(bx,by,bw,bh,'#ffffff');
  for(let i=0;i<lines.length;i++)text(lines[i],bx+3,by+3+i*7,'#140b20');
  px(cx-2,by+bh+1,1,2,'#140b20');px(cx+1,by+bh+1,1,2,'#140b20'); // queue de la bulle
  px(cx-1,by+bh,2,3,'#ffffff');
}
function updateNPCs(sp){
  // les NPC passent DEVANT les murs/ledges ; on evite seulement les ponts sureleves (ils marcheraient dans le vide)
  const nearBridge=obs.some(o=>o.k==='bridge'&&o.x<W+120&&o.x+o.w>-40);
  if(--npcT<=0&&npcs.length<3&&dist>600&&dist<LEVEL-800&&groundAt(W+30)===GROUND&&!nearBridge){
    npcT=irnd(260,640);
    const r=Math.random();
    // wv = vitesse propre dans le sens du skater (negatif = a contresens)
    let k,wv;
    if(r<.30){k='scooter';wv=-0.3;} // kid trottinette : roule tres lentement a contresens (DANGER)
    else if(r<.55){k='dogman';wv=0;} // l'homme au chien reste immobile sur le trottoir
    else if(r<.80){k='jog';wv=1.35;}
    else{k='gang';wv=0;}
    npcs.push({k,wv,x:W+30,f:irnd(0,99),cry:0});
  }
  for(const n of npcs){
    if(n.cry>0){n.cry--;n.x-=sp;continue;} // le kid crashe reste au sol et defile
    n.x-=sp-n.wv;n.f++;
    if(n.say>0)n.say--;
    // kid en trottinette : collision = wipeout mutuel, le kid se met a pleurer
    if(n.k==='scooter'&&P.crash===0&&P.inv===0&&!P.air&&!P.grind&&!P.wall&&P.y>=GROUND-2&&Math.abs(n.x-P.x)<11){ // collision uniquement au niveau du trottoir (pas en grind/wall/surface surelevee)
      n.cry=200;n.wv=0;
      tone('sawtooth',900,300,.2,.3);tone('square',700,180,.4,.25,.1); // couac + debut de pleurs
      wipeout();
      continue;
    }
    // near-miss : sauter par-dessus le kid en trottinette (style)
    if(n.k==='scooter'&&!n.nm&&P.air&&P.crash===0&&Math.abs(n.x-P.x)<12&&P.y<GROUND-8){
      n.nm=true;nearMiss(25,'NEAR MISS!');
    }
    // croisement : replique au hasard (2 fois/type; gang et kid ne parlent pas)
    if(n.k!=='gang'&&n.k!=='scooter'&&!(n.say>0)&&(npcSaid[n.k]||0)<2&&Math.abs(n.x-P.x)<28){
      npcSaid[n.k]=(npcSaid[n.k]||0)+1;
      n.sayLines=NPCLINES[n.k][irnd(0,NPCLINES[n.k].length-1)];
      n.say=130;
    }
  }
  npcs=npcs.filter(n=>n.x>-40);
}
// variantes fakie : on voit l'arriere de la tete (cheveux), pas le visage
const SPRF={};
for(const k in SPRITES){
  SPRF[k]=SPRITES[k].map(r=>r
    .replace('hSSSK','hHHHK')
    .replace('KHSSKSK','KHHHHHK')
    .replace('KsSSSK','KHHHHK'));
}
function rollFrame(ph){
  // cycle de poussee : delestage - appui vertical - extension arriere - repli 90 talon au ciel - ride
  if(ph<6)return['pushD',2];   // delestage : le corps se souleve, pied avant decolle brievement
  if(ph<16)return['pushB',5];  // pied plante verticalement contre la planche, poids devant
  if(ph<32)return['pushC',5];  // extension : le pied finit derriere le centre de masse
  if(ph<42)return['pushD',5];  // jambe repliee a 90, talon vers le ciel
  return['roll',0];
}
function pushOffset(ph){
  // dynamique : en retrait avant la poussee, acceleration vers l'avant a l'impulsion,
  // retour tranquille a la position habituelle, puis perte de terrain avant de repousser
  if(ph<16)return -4;
  if(ph<32)return -4+10*(ph-16)/16;
  if(ph<48)return 6-(ph-32)/16;
  if(ph<100)return 5-5*(ph-48)/52;
  return -4*(ph-100)/50;
}
function drawSpr(n,x,feetY){
  const f=(P.fakie?SPRF:SPRITES)[n],h=f.length,w=f[0].length,x0=(x-w/2)|0,y0=(feetY|0)-h+1;
  for(let r=0;r<h;r++)for(let c=0;c<w;c++){
    const ch=f[r][c];
    if(ch!=='.')px(x0+c,y0+r,1,1,PAL[ch]);
  }
}
function drawPlayer(){
  const x=P.x,y=P.y;
  if(P.inv>0&&P.crash===0&&((frame>>2)&1))return;
  // fakie : le skater est vu de l'autre cote jusqu'au prochain 180
  const mir=P.fakie;
  if(mir){ctx.save();ctx.translate(x,0);ctx.scale(-1,1);ctx.translate(-x,0);}
  if(P.crash>0){
    const t=50-P.crash;
    const bx=x+t*1.6,by=Math.min(GROUND-3,y-14+.045*t*t);
    drawBoard(bx,by,t*.4);
    ctx.save();ctx.translate(x,y-8);ctx.rotate(t*.22);
    drawSpr('air',0,6);
    ctx.restore();
    if(mir)ctx.restore();
    return;
  }
  if(P.wall){ // wall ride : dessus de planche face camera, orientee selon la phase (montee / traverse / descente)
    const wd=P.wallDir||0;
    if(P.wallBS){ // boardslide : pose complete en plongee (planche + skater) dans drawBoardSlide
      drawBoardSlide(x,y,P.wallBS);
    }else{
      drawBoardWallTop(x,y-3,wd*.45);          // nez vers le haut en montee, plat en traverse, vers le bas en descente
      ctx.save();ctx.translate(x,y-9);ctx.rotate(-.18+wd*.2); // pose : penche en arriere en montee, se redresse en descente
      drawSpr('air',0,7);
      ctx.restore();
    }
    if(mir)ctx.restore();
    return;
  }
  const FLIPS={kick:1,heel:-1,vkick:2,imposs:-2};
  const GRABTILT={grab:-.35,ngrab:-.45,tgrab:.45,indy:-.15,mute:.15};
  let bang=0,feet=y-5;
  if(P.grind)bang=(P.grind.k==='stairs'?.36:0)+P.lean*.28;
  else if(P.man)bang=(P.manNose?.32:-.32)+P.bal*.3;
  else if(P.rev>0)bang=Math.sin((12-P.rev)*.55)*.6;
  else if(P.air&&!P.trick){
    if(P.aoll===-1)bang=-.63;      // ollie manual : planche nose-up a 36 degres tout le saut
    else if(P.aoll===1)bang=.63;   // nollie : planche tail-up a 36 degres jusqu'a l'atterrissage
    else if(P.vy<0)bang=-Math.min(1,-P.vy/(P.popV||3))*.55; // ollie : nose up en montee, parallele des l'apex
  }
  if(P.trick){
    const pr=P.trick.t/P.trick.dur,f=FLIPS[P.trick.name];
    if(f){bang=f*pr*Math.PI*2;feet=y-9;}
    else if(P.trick.name==='shuv'||P.trick.name==='spin')bang=0; // rotations en yaw : planche a plat
    else bang=GRABTILT[P.trick.name]!==undefined?GRABTILT[P.trick.name]:-.35;
  }
  // FS/BS 180 : tout le skater tourne en yaw (ecrasement horizontal + miroir)
  const yaw=P.trick&&P.trick.name==='spin';
  if(yaw){
    const pr=P.trick.t/P.trick.dur,dir=(P.spinDir||1),sw=Math.sin(pr*Math.PI);
    ctx.save();ctx.translate(x,y-10);
    ctx.rotate(-dir*.22*sw);         // inclinaison opposee FS/BS
    let sx=Math.cos(Math.min(1,pr)*Math.PI);
    if(Math.abs(sx)<.15)sx=sx<0?-.15:.15;
    ctx.scale(sx,1);ctx.translate(-x,-(y-10));
  }
  if(P.trick&&P.trick.name==='shuv')drawBoardShuv(x,y-3,P.trick.t/P.trick.dur);
  else drawBoard(x,y-3,bang);
  let mode='roll',off=0;
  if(P.grind||P.man||P.slide>0||(!P.air&&P.crouch>0))mode='grind';
  else if(P.air)mode=P.trick?((P.trick.name==='shuv'||P.trick.name==='spin')?'roll':(GRABTILT[P.trick.name]!==undefined?'grab':'air')):(P.vy<-1.4?'grind':'air'); // yaw : corps droit
  else if(P.rev<=0)[mode,off]=rollFrame(P.pushT%150);
  drawSpr(mode,x,feet+off);
  if(yaw)ctx.restore();
  if(mir)ctx.restore();
}
// avion publicitaire : pur decor de ciel (aucune collision, aucun son), vitesse propre 0.5 px/f
// independante de speed/dist ; vit hors des parties (pas reinitialise par startGame)
const plane={x:W+40,wait:300};                       // wait = frames avant la premiere apparition
const PLANE_PW=30+(textW(BANNER_TXT)+8);             // biplan (~25) + cable (5) + panneau (texte fixe, precalcule)
// panneau pre-rendu une fois dans un canvas offscreen (texte statique) : permet l'ondulation par colonnes
const bnCv=document.createElement('canvas');
{
  const bw=textW(BANNER_TXT)+8;
  bnCv.width=bw;bnCv.height=9;
  const main=ctx;ctx=bnCv.getContext('2d');          // px()/text() dessinent dans le panneau
  px(0,0,bw,9,'#140b20');                            // bordure 1 px (contour universel)
  px(1,1,bw-2,7,'#ffe9f7');                          // fond clair
  text(BANNER_TXT,4,2,'#43115f');                    // 3x5 sans ombre (fond plein = contraste)
  ctx=main;
}
function drawPlane(){
  if(state!=='pause'){ // gele en pause : l'avancement vit ici, pas de position pilotee par frame
    if(plane.wait>0){plane.wait--;return;}
    plane.x-=.5;
    if(plane.x<-PLANE_PW-40){plane.x=W+40;plane.wait=1500;return;} // ~25 s hors ecran entre deux passages
  }else if(plane.wait>0)return;
  const x=plane.x|0,y=36;
  // --- biplan cartoon (~25x15, nez a gauche) : gros contours #140b20, palette existante
  // aile superieure (orange, au-dessus du fuselage, s'arrete avant le cockpit)
  px(x+2,y-7,12,4,'#140b20');                        // contour epais
  px(x+3,y-6,10,2,'#ff7f11');
  px(x+3,y-6,10,1,'#ffd319');                        // arete d'aile eclairee
  // mats + haubans (entre aile haute et fuselage)
  px(x+5,y-3,1,2,'#140b20');px(x+11,y-3,1,2,'#140b20'); // 2 mats verticaux
  px(x+7,y-3,1,1,'#b5793e');px(x+8,y-2,1,1,'#b5793e');  // hauban diagonal suggere
  // derive arriere (triangle rouge, marche d'escalier)
  px(x+19,y-6,5,6,'#140b20');                        // contour
  px(x+21,y-5,2,1,'#ff3355');
  px(x+20,y-4,3,3,'#ff3355');
  // fuselage trapu creme + queue
  px(x+2,y-2,19,5,'#140b20');                        // contour epais
  px(x+4,y-1,15,3,'#ffcf9f');
  px(x+4,y-1,4,1,'#ffe9f7');                         // petit reflet au capot
  px(x+18,y-1,3,2,'#ffcf9f');                        // queue effilee vers la derive
  // nez : cone rouge
  px(x+2,y-1,2,3,'#ff3355');
  // pilote dans le cockpit ouvert (casque brun, lunettes, echarpe bleue)
  px(x+14,y-5,4,4,'#140b20');                        // contour tete
  px(x+15,y-4,2,1,'#b5793e');                        // casque
  px(x+15,y-3,1,1,'#140b20');                        // lunettes (regard vers l'avant)
  px(x+16,y-3,1,1,'#ffcf9f');                        // visage
  px(x+14,y-2,3,1,'#2f7ce0');                        // echarpe bleue au col
  px(x+17,y-2+(((frame>>3)&1)?0:1),1,1,'#2f7ce0');   // bout d'echarpe qui flotte
  // stabilisateur arriere (orange)
  px(x+19,y+1,5,2,'#140b20');
  px(x+20,y+1,4,1,'#ff7f11');
  // aile inferieure (orange, sous le fuselage)
  px(x+4,y+2,12,3,'#140b20');                        // contour epais
  px(x+5,y+3,10,1,'#ff7f11');
  // roulette de queue
  px(x+18,y+3,2,2,'#140b20');px(x+18,y+3,1,1,'#7a5548');
  // helice sombre a bouts rouges : 2 poses
  if((frame>>2)&1){
    px(x,y-5,1,11,'#3d4266');
    px(x,y-5,1,2,'#ff3355');px(x,y+4,1,2,'#ff3355'); // bouts rouges
  }else{
    px(x,y-2,1,5,'#3d4266');px(x-1,y,3,1,'#3d4266');
    px(x,y-2,1,1,'#ff3355');px(x,y+2,1,1,'#ff3355');
  }
  px(x+1,y,1,1,'#140b20');                           // moyeu sombre
  // --- banniere : ondulation de tissu par colonnes (sinusoide progressive, amplitude croissante vers la fuite)
  const bw=bnCv.width,bx=x+30;
  const wv=i=>(Math.sin(frame*.07-i*.055)*(i<bw-10?1.4:2.3))|0; // onde lente, +-1 px sur le corps (texte lisible), +-2 sur les ~10 dernieres colonnes
  const dy0=wv(0);
  px(x+24,y-1+dy0,4,1,'#140b20');                    // cable en 2 segments, accroche qui suit la 1re colonne
  px(x+27,y+dy0,3,1,'#140b20');
  for(let i=0;i<bw;i+=2){
    const cw=Math.min(2,bw-i);
    ctx.drawImage(bnCv,i,0,cw,9,bx+i,31+wv(i),cw,9); // colonnes entieres decalees au pixel
  }
  // echancrure de bord de fuite qui claque au vent (2 px, alternance rapide)
  const ed=wv(bw-1);
  px(bx+bw-2,32+ed+(((frame>>2)&1)?0:5),1,2,'#140b20');
}
function drawTrain(){ // train de banlieue 2 niveaux : masse sombre d'arriere-plan (violets/gris-bleu desatures), fenetres discretes
  if(!train)return;
  const roof=GROUND-TR_H;
  for(let i=0;i<TR_N;i++){
    const wx=(train.x+i*(TR_WL+TR_GAP))|0;
    if(wx>W+10||wx+TR_WL<-10)continue;
    if(i<TR_N-1)px(wx+TR_WL-2,roof+TR_DIP+4,TR_GAP+4,4,'#140b20'); // attelage dans le creux
    // partie haute biseautee (silhouette = profil praticable trainTopAt)
    for(let r=0;r<TR_DIP;r++){
      const ins=((TR_BEV*(TR_DIP-r))/TR_DIP)|0;
      px(wx+ins,roof+r,TR_WL-2*ins,1,'#2a1250');
      px(wx+ins,roof+r,1,1,'#4a4460');px(wx+TR_WL-ins-1,roof+r,1,1,'#4a4460'); // bords du biseau (mi-ton)
    }
    px(wx+TR_BEV,roof,TR_WL-2*TR_BEV,1,'#6b5aa0');   // arete de toit : fine ligne claire discrete (surface praticable)
    px(wx,roof+TR_DIP,TR_WL,1,'#140b20');            // ligne d'epaule
    // bandeau superieur sombre + rangee de fenetres du haut (discretes)
    px(wx,roof+TR_DIP+1,TR_WL,7,'#2a1250');
    for(let fx=wx+6;fx<wx+TR_WL-8;fx+=9)px(fx,roof+TR_DIP+2,5,4,'#5b6390');
    // flanc gris-bleu (niveau intermediaire)
    px(wx,roof+TR_DIP+8,TR_WL,2,'#4a4460');
    px(wx,roof+TR_DIP+10,TR_WL,8,'#3d4266');
    // bande basse sombre : fenetres du bas + porte au centre
    px(wx,roof+TR_DIP+18,TR_WL,10,'#2a1250');
    for(let fx=wx+6;fx<wx+TR_WL-8;fx+=9)px(fx,roof+TR_DIP+20,4,4,'#5b6390');
    px(wx+TR_WL/2-3,roof+TR_DIP+18,6,10,'#4a4460');px(wx+TR_WL/2,roof+TR_DIP+18,1,10,'#140b20'); // porte double
    // jupe + chassis
    px(wx,roof+TR_DIP+28,TR_WL,4,'#37324a');
    px(wx,roof+TR_DIP+32,TR_WL,1,'#140b20');
    px(wx,roof,1,TR_DIP+33,'#140b20');px(wx+TR_WL-1,roof,1,TR_DIP+33,'#140b20'); // montants
    // bogies : deux blocs sombres avec roues
    for(const bx of [wx+12,wx+TR_WL-26]){
      px(bx,GROUND-5,14,4,'#140b20');
      px(bx+2,GROUND-3,3,3,'#0f0a1e');px(bx+9,GROUND-3,3,3,'#0f0a1e');
    }
    if(i===0){px(wx+1,roof+TR_DIP+22,2,3,'#ffd319');} // phare du nez (petit point jaune, signal du contresens)
  }
}
function drawWorld(){
  ctx.drawImage(bgSky,0,0);
  for(const s of stars)if(Math.sin(frame*.05+s.p)>-.2)px(s.x,s.y,s.s,s.s,'#ffe9f7');
  drawSun();
  px(0,HORIZON,W,1,'#ff77a8');
  drawBuildings(FAR,HORIZON,'#2a1250','#c9a227','#4fd8e0',.12);
  drawBuildings(NEAR,126,'#180b33','#8a4a68','#3fa7ad',.3);
  drawPlane(); // devant la skyline (lisibilite), derriere les palmiers (profondeur)
  for(let k=0;k<5;k++){
    const sx=((k*132-dist*.55)%660+660)%660-40;
    drawPalm(sx,151,13+(k%3)*3);
  }
  drawStreet();
}
function drawStreet(){
  // trottoir (surface de ride)
  px(0,GROUND,W,6,'#2b2150');
  px(0,GROUND,W,1,'#6b5aa0');
  for(const j of ST.j){
    const sx=stWrap(j-dist);
    if(sx<W)px(sx,GROUND+1,1,5,'#1a1238');
  }
  // grilles d'egout contre la bordure
  for(const g of ST.gr){
    const sx=stWrap(g-dist);
    if(sx<W-8){
      px(sx,GROUND+2,8,3,'#0f0a1e');
      px(sx+1,GROUND+3,1,1,'#4a3e78');px(sx+3,GROUND+3,1,1,'#4a3e78');px(sx+5,GROUND+3,1,1,'#4a3e78');
    }
  }
  // chaussee en contrebas
  px(0,GROUND+6,W,H-GROUND-6,'#191128');
  px(0,GROUND+6,W,1,'#0f0a1e');
  // texture asphalte (leger parallaxe : plus bas = plus proche = plus vite)
  for(const s of ST.sp){
    const sx=stWrap(s.x-dist*(s.y>12?1.14:1.05));
    if(sx<W-3)px(sx,GROUND+6+s.y,s.w,1,s.c);
  }
  // intersections : la rue transversale coupe le trottoir (une a chaque 1500px)
  for(let k=1;k*CROSSPER<LEVEL;k++){
    const cc0=BASEX+(k*CROSSPER-dist),cc1=cc0+CROSSLEN;
    if(cc1<0||cc0>W)continue;
    px(cc0,GROUND,cc1-cc0,6,'#191128');
    px(cc0,GROUND,1,6,'#0f0a1e');          // face de la bordure (descente)
    px(cc1-1,GROUND,1,6,'#0f0a1e');        // face de la bordure (remontee)
    px(cc1,GROUND,2,1,'#a393dd');          // arete du trottoir qui reprend
  }
  // ligne centrale avec lueur
  for(let x=-((dist*1.08)%38);x<W;x+=38){
    px(x,GROUND+13,15,1,'#0d4f52');
    px(x,GROUND+14,15,1,'#3fe0d0');
    px(x+1,GROUND+15,13,1,'#0d4f52');
  }
  // plaques d'egout
  for(const m of ST.man){
    const sx=stWrap(m-dist*1.1);
    if(sx<W-14){
      px(sx,GROUND+19,12,4,'#0f0a1e');
      px(sx+1,GROUND+19,10,1,'#3a2f60');
      px(sx+2,GROUND+21,3,1,'#2a2050');px(sx+7,GROUND+21,3,1,'#2a2050');
    }
  }
  // flaques aux reflets neon
  for(const pd of ST.pud){
    const sx=stWrap(pd.x-dist*1.12);
    if(sx<W-26){
      px(sx,GROUND+23,pd.w,2,'#241a4a');
      px(sx+2,GROUND+23,pd.w-4,1,(frame>>3)&1?'#ff2975':'#7a3f8f');
      px(sx+(pd.w/2|0),GROUND+24,3,1,'#3fe0d0');
    }
  }
  px(0,H-2,W,2,'#120b22');
}
function drawHUD(){
  textSh('SCORE '+String(score|0).padStart(6,'0'),5,5,'#ffffff','#43115f');
  textCSh('HI '+String(hi|0).padStart(6,'0'),W/2,5,'#9f8fd0','#2a0a3f');
  const remM=Math.max(0,Math.ceil((LEVEL-dist)/PXM));
  textSh(remM+'M',W-6-textW(remM+'M'),5,remM<=30?((frame>>3)&1?'#ff2975':'#ffffff'):'#ffffff','#43115f');
  if(chain&&chain.cnt>0){
    const M=Math.min(10,Math.max(1,chain.cnt));
    const big=M>=4?2:1;
    const mc=M>=7?((frame>>2)&1?'#ff2975':'#fff')
            :M>=5?'#ffd319'
            :M>=3?'#00fff0':'#ffffff';
    textCSh(chain.pts+'  X'+M,W/2,14,mc,'#221144',big);
    const GW=48,gx=(W/2-GW/2)|0,gy=big>1?27:23;
    const frozen=P.air||P.grind||P.wall||P.man>0||P.slide>0||P.rev>0;
    const ratio=Math.max(0,Math.min(1,chain.link/chain.linkMax));
    const fw=frozen?GW:Math.ceil(GW*ratio);
    const gc=frozen?((frame>>2)&1?'#00fff0':'#7dfff5')
            :ratio>0.6?'#00fff0'
            :ratio>0.3?'#ffd319'
            :((frame>>1)&1?'#ff2975':'#ff6b9d');
    px(gx,gy+1,GW,2,'#221144');
    px(gx,gy,GW,2,'#3a2f60');
    if(fw>0)px(gx,gy,fw,2,gc);
  }
  if(demo&&(frame/28|0)%2)textCSh('DEMO ... APPUIE SUR SPACE POUR JOUER',W/2,28,'#ffffff','#43115f');
  if(!demo&&firstRun&&playT<620&&state==='play'){
    const tips=IS_MOBILE?[
      'GAUCHE = SAUTS ... DROITE = TRICKS',
      'GAUCHE : TAP = PETIT SAUT ... SWIPE HAUT = OLLIE',
      'GAUCHE : SWIPE BAS TENU PUIS HAUT = OLLIE CHARGE',
      'DROITE : SWIPE GAUCHE/DROITE AU SOL = MANUAL / NOSE MANUAL',
      'LE MANUAL DURE 2 SECONDES',
      'EN L\'AIR : SWIPE G/D = 180 ... RE-SWIPE = 360, 540...',
      'EN L\'AIR : TAP = GRAB ... SWIPE = GRABS/FLIPS',
      'DIAGONALES = FLIPS (BAS+DROITE = KICKFLIP)',
      'CROUCH GAUCHE + SWIPE DROITE = FLIP CHARGE',
      'DROITE : SWIPE HAUT BREF = POP SHUVIT ... TENU = WALL RIDE',
      'SUR RAIL : SWIPE G/D = LEAN, BAS = DROP, TAP = POP OUT',
      'EN FAKIE ON RALENTIT ... REFAIS UN 180 !',
      'OLLIE CHARGE + BON TIMING = BIG GAP A L\'INTERSECTION',
      'GARE AU KID EN TROTTINETTE ... SAUTE-LE !',
      'ENCHAINE LES TRICKS ... AUCUNE CHUTE, JUSTE DU STYLE'
    ]:['SPACE = PETIT SAUT ... BAS + SPACE = OLLIE','TIENS BAS (CROUCH) AVANT SPACE = OLLIE CHARGE','RELACHE GAUCHE/DROITE AU SOL = MANUAL / NOSE MANUAL','LE MANUAL DURE 2 SECONDES','GAUCHE OU DROITE TENU + SPACE = PETIT SAUT 180','EN L\'AIR : SPACE = GRAB, FLECHE+SPACE = GRABS/FLIPS','HOP 180 (G/D+SPACE) : UN SPACE DE PLUS = 360, 540...','DIAGONALES + SPACE = FLIPS (BAS+DROITE = KICKFLIP)','HAUT + SPACE = POP SHUVIT','EN L\'AIR : RELACHE GAUCHE/DROITE = PREPARE 5-0 / NOSE GRIND','SUR RAIL : G/D = LEAN, BAS = DROP, SPACE = POP OUT','FLECHE HAUT LE LONG D\'UN LEDGE/PLATEAU = WALL RIDE','EN FAKIE ON RALENTIT ... REFAIS UN 180 !','OLLIE CHARGE + BON TIMING = BIG GAP A L\'INTERSECTION','GARE AU KID EN TROTTINETTE ... SAUTE-LE !','ENCHAINE LES TRICKS ... AUCUNE CHUTE, JUSTE DU STYLE'];
    textCSh(tips[Math.floor(playT/125)%tips.length],W/2,170,'#c8bfe8','#221144');
  }
}
function drawTitle(){
  dist+=.7;bgDist+=.7;
  drawWorld();
  const tx=((frame*1.4)%(W+80))-40;
  drawBoard(tx,GROUND-3,0);
  const[tn,toff]=rollFrame(frame%150);
  drawSpr(tn,tx,GROUND-5+toff);
  const wob=Math.sin(frame*.06)*2;
  textCSh('KICKFLIP',W/2,26+wob,'#00fff0','#0a4f66',4);
  textCSh('CITY',W/2,52+wob,'#ffd319','#7a3b00',4);
  px(W/2-34,80+wob,68,1,'#ff2975');
  if(IS_MOBILE){ // tactile : instructions gestes
    if((frame/28|0)%2)textCSh('TAP TO SHRED',W/2,90,'#ffffff','#43115f');
    textCSh('LEFT = JUMPS ... RIGHT = TRICKS',W/2,106,'#9f8fd0','#221144');
    textCSh('SWIPE EN L\'AIR = FLIPS & SPINS',W/2,114,'#9f8fd0','#221144');
    // iPhone : pas de rotation forcee possible -> on invite a passer en paysage
    if(innerHeight>innerWidth&&(frame/22|0)%2)textCSh('TOURNE TON TELEPHONE (PAYSAGE)',W/2,126,'#ffd319','#5f3a00');
  }else{
    if((frame/28|0)%2)textCSh('PRESS SPACE TO SHRED',W/2,90,'#ffffff','#43115f');
    textCSh('SPACE TO POP',W/2,106,'#9f8fd0','#221144');
    textCSh('ARROWS & COMBINATIONS FOR TRICKS',W/2,114,'#9f8fd0','#221144');
  }
  if(hi>0)textCSh('HI SCORE '+String(hi|0).padStart(6,'0'),W/2,136,'#ffd319','#5f3a00');
  if(!IS_MOBILE){ // raccourcis purement clavier : caches au tactile (l'icone fullscreen reste)
    text('M SOUND - D DEMO',5,163,'#584a85');
    text('F FULLSCREEN',5,170,'#584a85');
  }
  textC('(C) BOUTIQUE ADRENALINE 2026',W/2,170,'#3fe0d0');
  drawFSIcon();
}
function drawOver(){
  if(demo&&frame-overF>240){demo=false;state='title';idleT=0;return;}
  drawWorld();
  drawTrain();
  for(const o of obs)drawObs(o);
  ctx.fillStyle='rgba(13,2,33,.75)';ctx.fillRect(0,0,W,H);
  textCSh('FINISH!',W/2,44+Math.sin(frame*.1),'#ffd319','#7a3b00',4);
  textCSh('SCORE '+String(score|0).padStart(6,'0'),W/2,84,'#ffffff','#43115f',2);
  if(newHi){if((frame/12|0)%2)textCSh('NEW HI SCORE!',W/2,102,'#ffd319','#5f3a00');}
  else textCSh('HI '+String(hi|0).padStart(6,'0'),W/2,102,'#9f8fd0','#2a0a3f');
  if(frame-overF>30&&(frame/28|0)%2)textCSh('PRESS SPACE TO SHRED AGAIN',W/2,126,'#00fff0','#0a4f66');
  drawLogo(W/2,136);
  drawFSIcon();
}
function draw(){
  ctx.clearRect(0,0,W,H);
  if(state==='splash'){drawSplash();return;}
  if(state==='title'){drawTitle();return;}
  if(state==='over'){drawOver();return;}
  ctx.save();
  if(shake>0)ctx.translate(rnd(-1,1)*shake*.6,rnd(-1,1)*shake*.5);
  drawWorld();
  drawTrain(); // derriere tous les obstacles et les pietons du trottoir, devant le decor
  for(const o of obs)drawObs(o);
  for(const n of npcs)drawNPC(n);   // NPC devant les murs/ledges
  if(state!=='over'&&LEVEL-dist<W+40)drawFinish(BASEX+(LEVEL-dist));
  drawPlayer();
  for(const p of parts)px(p.x,p.y,p.l>20?2:1,p.l>20?2:1,p.c);
  for(const n of npcs)if(n.say>0)drawBubble(n);
  for(const p of pops)textCSh(p.t,p.x,p.y,p.c,'#221144',p.s); // texte de trick au-dessus des bulles NPC
  ctx.restore();
  drawHUD();
  if(state==='pause'){
    ctx.fillStyle='rgba(13,2,33,.6)';ctx.fillRect(0,0,W,H);
    textCSh('PAUSED',W/2,80,'#ffffff','#43115f',2);
    textCSh('P TO RESUME',W/2,100,'#9f8fd0','#221144');
  }
  drawFSIcon();
}
//============================================================ INPUT
// SPACE = pop / action. Le contexte (sol, air, rail, manual) decide du trick.
function pop(){
  ac();
  if(state==='splash'){state='title';return;}
  if(state==='title'){fsEnterMobile();startGame();return;}
  if(state==='over'){if(frame-overF>30){firstRun=false;fsEnterMobile();startGame();}return;}
  if(state==='pause'){state='play';return;}
  if(state!=='play'||P.crash>0)return;
  held=true;
  const l=KD.l,r=KD.r,u=KD.u,d=KD.d;
  if(P.wall){ // Espace pendant un wall ride : kick-off stylé dans les airs
    P.wall=null;grindStop();P.jumpFromY=P.y;P.air=true;P.vy=-3.0;P.popV=3;P.rot=0;P.aoll=0;P.spinCount=0;P.airTricked=true;P.wallCD=16;P.x-=6;sJump();
    if(l||r)spin180(l?-1:1);        // Haut relaché + G/D = 180 en sortie de mur
    return;
  }
  if(P.grind){ // pop out : tous les tricks sont autorises en sortie de grind
    const gl=P.lean; // lean actuel (5-0 / 50-50 / crooked) a preserver sur un 180
    P.grind=null;P.lean=0;grindStop();
    // meme regle qu'au sol : toute sortie de grind (pop out, 180, flip, shuvit)
    // part a hauteur petit saut / pop shuvit (-1.8)
    P.jumpFromY=P.y;P.air=true;P.vy=-1.8;P.popV=1.8;P.rot=0;P.aoll=0;P.spinCount=0;sJump();
    if(d&&r)doTrick('kick','KICKFLIP',22,60);
    else if(d&&l)doTrick('heel','HEELFLIP',22,60);
    else if(u&&r)doTrick('vkick','VARIAL KICKFLIP',24,80);
    else if(u&&l)doTrick('imposs','IMPOSSIBLE',26,90);
    else if(u)doTrick('shuv','POP SHUVIT',18,50);
    // 180 en sortie de grind : le 180 inversera l'equilibre a l'atterrissage (5-0 <-> nose)
    else if(l){P.aoll=gl;spin180(-1);}
    else if(r){P.aoll=gl;spin180(1);}
    return;
  }
  if(!P.air){ // contexte sol
    // Hauteurs : petit saut et flips = hauteur pop shuvit (-1.8, juste assez pour
    // monter ledges et rails), partout (sol comme sortie de grind). Ollie (-3.0,
    // tout juste le pont en flottant) / ollie charge (jusqu'a -3.9) pour la hauteur,
    // ou saut d'abord puis flip en l'air (le flip garde la hauteur du saut).
    const ch=Math.min(30,P.crouch),chg=ch>=15; // charge : crouch (bas) tenu avant le pop
    if(d&&r){jump(-(1.8+ch*.03));P.charged=chg;doTrick('kick','KICKFLIP',22,50);}   // flip charge = combo ollie charge
    else if(d&&l){jump(-(1.8+ch*.03));P.charged=chg;doTrick('heel','HEELFLIP',22,50);}
    else if(u&&r){jump(-1.8);doTrick('vkick','VARIAL KICKFLIP',24,70);}
    else if(u&&l){jump(-1.8);doTrick('imposs','IMPOSSIBLE',26,80);}
    // ollie : depuis un manual, on prepare le grind correspondant (manual->5-0, nose manual->nosegrind)
    else if(d){const mn=P.man>0?P.manNose:null;jump(-(3.0+ch*.03));P.charged=chg;if(mn!==null)P.aoll=mn?1:-1;}
    else if(u){jump(-1.8);doTrick('shuv','POP SHUVIT',18,40);} // petit saut, la planche tourne a 180 sous les pieds
    // petit saut 180 : depuis un manual, on retombe dans le MEME manual (fakie via le 180)
    else if(l){const mn=P.man>0?P.manNose:null;jump(-1.8);if(mn!==null){P.aoll=mn?1:-1;P.relandMan=true;}spin180(-1);}
    else if(r){const mn=P.man>0?P.manNose:null;jump(-1.8);if(mn!==null){P.aoll=mn?1:-1;P.relandMan=true;}spin180(1);}
    // petit saut : depuis un manual, prepare aussi le grind correspondant
    else{const mn=P.man>0?P.manNose:null;jump(-1.8);if(mn!==null)P.aoll=mn?1:-1;}
  }else{ // contexte air
    if(P.trick){
      // fleche tenue (sans haut/bas) + un autre espace pendant le spin = +180 (360, 540...)
      if(P.trick.name==='spin'&&(l||r)&&!u&&!d)spin180(l?-1:1);
      return;
    }
    if(d&&r)doTrick('kick','KICKFLIP',22,50);
    else if(d&&l)doTrick('heel','HEELFLIP',22,50);
    else if(u&&r)doTrick('vkick','VARIAL KICKFLIP',24,70);
    else if(u&&l)doTrick('imposs','IMPOSSIBLE',26,80);
    else if(u)doTrick('ngrab','NOSE GRAB',26,50);
    else if(d)doTrick('tgrab','TAIL GRAB',26,50);
    // fleche gauche/droite tenue + espace = 180 (chaque espace suivant ajoute un 180)
    else if(l||r)spin180(l?-1:1);
    else doTrick('grab','MELON GRAB',26,40);
  }
}
// Le clavier appartient a la page (recherche du header, formulaires) des qu'un
// champ de saisie a le focus : le jeu ignore alors tout et ne bloque pas l'espace.
const typing=t=>t&&(t.matches?.('input,textarea,select,[contenteditable],[contenteditable] *')||t.closest?.('input,textarea,select,[contenteditable]'));
addEventListener('keydown',e=>{
  if(typing(e.target))return;
  const k=e.key;
  if([' ','ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(k))e.preventDefault();
  idleT=0;
  if(state==='splash'){state='title';return;} // toute touche saute l'ecran studio
  if(demo&&state!=='title'){demo=false;startGame();} // toute touche reprend la main sur la demo
  // armL/armR : une fleche n'arme le manual que si elle est tapee SEULE (pas avec bas/haut)
  if(k==='ArrowLeft'||k==='a'||k==='A'){KD.l=true;if(!e.repeat){pendL=true;armL=!KD.d&&!KD.u;}}
  else if(k==='ArrowRight'||k==='d'||k==='D'){KD.r=true;if(!e.repeat){pendR=true;armR=!KD.d&&!KD.u;}}
  else if(k==='ArrowUp'||k==='w'||k==='W'){KD.u=true;armL=armR=false;}          // diagonale : desarme
  else if(k==='ArrowDown'||k==='s'||k==='S'){KD.d=true;if(!e.repeat){lastDownF=frame;if(P.air)P.airDown=true;}armL=armR=false;}
  if(e.repeat)return;
  if(k===' '){pop();armL=armR=false;} // un pop/trick consomme la fleche : pas de manual sur son relachement
  else if(k==='m'||k==='M'){ac();AU.mut=!AU.mut;if(AU.master)AU.master.gain.value=AU.mut?0:.16;if(AU.mut)grindStop();}
  else if(k==='f'||k==='F')toggleFS();
  else if(k==='p'||k==='P'||k==='Escape'){if(state==='play')state='pause';else if(state==='pause')state='play';}
  else if((k==='d'||k==='D')&&state==='title'){ac();demo=true;demoNext=0;startGame();}
});
addEventListener('keyup',e=>{
  const k=e.key,L=(k==='ArrowLeft'||k==='a'||k==='A'),R=(k==='ArrowRight'||k==='d'||k==='D');
  if(k===' ')held=false;
  else if(L||R){
    if(L)KD.l=false;else KD.r=false;
    const armed=L?armL:armR;
    if(state==='play'&&!demo&&P.crash===0&&armed){ // seulement si la fleche etait armee (tap propre)
      if(!P.air&&!P.grind&&!P.man&&P.slide<=0&&P.rev<=0&&!KD.d&&!KD.u){
        startManual(R); // au sol : manual (G) / nose manual (D) de 3s
      }else if(P.air){
        upL=L;upR=R;    // en l'air : prepare l'accroche au rail
      }
    }
    if(L)armL=false;else armR=false;
  }
  else if(k==='ArrowUp'||k==='w'||k==='W')KD.u=false;
  else if(k==='ArrowDown'||k==='s'||k==='S'){KD.d=false;P.airDown=false;}
});
// ===== FULLSCREEN integre : icone pixel au canvas (coin bas-droit) + touche F, bascule entree/sortie =====
// iPhone Safari n'a pas d'API Fullscreen pour les elements (video seulement) :
// repli "faux plein ecran" = classe fs-fake sur le wrap (overlay fixed plein viewport).
let fsFake=false;
function fsOn(){return fsFake||!!(document.fullscreenElement||document.webkitFullscreenElement);}
function fsFakeSet(on){
  fsFake=on;
  document.getElementById('fred-game-wrap').classList.toggle('fs-fake',on);
  document.documentElement.classList.toggle('fs-lock',on);
}
function lockLandscape(){ // Android : le verrouillage d'orientation n'est permis qu'en plein ecran
  try{if(IS_MOBILE&&screen.orientation&&screen.orientation.lock)screen.orientation.lock('landscape').catch(()=>{});}catch(e){}
}
function unlockOrient(){try{if(screen.orientation&&screen.orientation.unlock)screen.orientation.unlock();}catch(e){}}
for(const ev of['fullscreenchange','webkitfullscreenchange'])
  document.addEventListener(ev,()=>{if(!document.fullscreenElement&&!document.webkitFullscreenElement)unlockOrient();});
function toggleFS(){
  try{
    if(fsOn()){
      if(fsFake)fsFakeSet(false);
      else{const f=document.exitFullscreen||document.webkitExitFullscreen;f&&f.call(document);}
    }else{
      const el=document.getElementById('fred-game-wrap'),f=el.requestFullscreen||el.webkitRequestFullscreen;
      if(f){const r=f.call(el);if(r&&r.then)r.then(lockLandscape,()=>{fsFakeSet(true);});else lockLandscape();}
      else fsFakeSet(true); // iPhone : pas d'API -> faux plein ecran (pas de rotation possible, hint a l'ecran titre)
    }
  }catch(e){}
}
function fsEnterMobile(){ // demarrage d'une partie au tactile : plein ecran + paysage automatiques
  if(IS_MOBILE&&!fsOn())toggleFS();
}
function fsHit(cx,cy){ // zone de hit tactile (coin haut-droit) autour de l'icone 15x9
  const r=cv.getBoundingClientRect();
  const x=(cx-r.left)*W/r.width,y=(cy-r.top)*H/r.height;
  return x>=W-36&&y<=30;
}
function drawFSIcon(){ // rectangle horizontal 15x9, 4 equerres, contraste eleve ; barre centrale quand actif
  const x=W-24,y=14,c='#00fff0',sh='#1a0f33'; // cyan permanent ; haut-droit avec marge, sous la distance du HUD (y 5-9)
  px(x-3,y-3,21,15,'rgba(13,2,33,.68)'); // plaque sombre : garde l'icone lisible meme canvas reduit / ciel clair
  px(x+1,y+1,4,1,sh);px(x+1,y+1,1,3,sh);px(x+12,y+9,4,1,sh);px(x+15,y+7,1,3,sh); // ombre
  px(x,y,4,1,c);px(x,y,1,3,c);           // coin haut-gauche
  px(x+11,y,4,1,c);px(x+14,y,1,3,c);     // haut-droit
  px(x,y+8,4,1,c);px(x,y+6,1,3,c);       // bas-gauche
  px(x+11,y+8,4,1,c);px(x+14,y+6,1,3,c); // bas-droit
  if(fsOn())px(x+5,y+3,5,3,c);           // plein ecran actif
}
const wrap=document.getElementById('fred-game-wrap');
// ===== TACTILE : controles gestuels, deux zones (moitie gauche / moitie droite du canvas) =====
// GAUCHE (sauts) : tap = petit saut ; swipe HAUT = ollie ;
//                  swipe BAS tenu = crouch, puis swipe HAUT = ollie charge (relacher sans haut = annule)
// DROITE (tricks) : tap = pop contextuel (grab / pop out) ; doigt tenu = pop + air flottant
//   SOL  : swipe G/D = manual/nose manual, BAS tenu = crouch, HAUT bref = pop shuvit / tenu = wall ride,
//          diagonale = ollie + flip (BAS+DROITE = kickflip)
//   AIR  : swipe G/D = 180 (re-swipe = 360, 540...), HAUT = nose grab, BAS = tail grab, diagonales = flips
//   RAIL : swipe G = lean F/S, D = lean B/S, BAS = drop, diagonale = pop out + flip, tap = pop out
//   MUR  : swipe G/D = boardslide, HAUT tenu = monter, tap = kick-off
// DEUX POUCES : crouch gauche tenu + geste droit = version chargee (ex. + swipe D = kickflip charge)
const SWIPE=16;      // seuil de declenchement d'un swipe (px canvas)
const PRESS_MS=140;  // au-dela sans bouger : press (pop immediat + held)
let tg=null;         // geste tactile en cours (zone droite)
let tgL=null;        // geste tactile en cours (zone gauche : sauts)
function cvPt(t){const r=cv.getBoundingClientRect();return{x:(t.clientX-r.left)*W/r.width,y:(t.clientY-r.top)*H/r.height};}
function swipeFlags(dx,dy){ // 8 secteurs : composante gardee si > sin(22.5) de la norme
  const n=Math.hypot(dx,dy)||1,f={l:false,r:false,u:false,d:false};
  if(Math.abs(dx)>n*.383)f[dx<0?'l':'r']=true;
  if(Math.abs(dy)>n*.383)f[dy<0?'u':'d']=true;
  return f;
}
function touchPop(f){ // pop() avec des directions simulees, puis restauration du vrai clavier
  const l=KD.l,r=KD.r,u=KD.u,d=KD.d;
  KD.l=!!f.l;KD.r=!!f.r;KD.u=!!f.u;KD.d=!!f.d;
  pop();
  KD.l=l;KD.r=r;KD.u=u;KD.d=d;
}
function tgClear(){
  if(!tg)return;
  if(tg.holdD){KD.d=false;P.airDown=false;}
  if(tg.holdU)KD.u=false;
  if(tg.timer){clearTimeout(tg.timer);tg.timer=null;}
  tg=null;
}
function tgLClear(){
  if(!tgL)return;
  if(tgL.crouch){KD.d=false;P.airDown=false;}
  tgL=null;
}
const leftCrouch=()=>!!(tgL&&tgL.crouch); // crouch tenu du pouce gauche (combos deux pouces)
wrap.addEventListener('touchstart',e=>{
  e.preventDefault();idleT=0;
  const t=e.changedTouches[0];
  if(fsHit(t.clientX,t.clientY)){toggleFS();return;} // coin fullscreen : pas d'action de jeu
  if(demo&&state!=='title'){demo=false;fsEnterMobile();startGame();return;}
  if(state!=='play'){pop();held=false;return;} // menus : tap = avancer
  if(P.crash>0)return;
  const p=cvPt(t);
  if(p.x<W/2){ // ZONE GAUCHE : sauts
    if(tgL)return; // un seul pouce gauche a la fois
    tgL={id:t.identifier,x:p.x,y:p.y,crouch:false,done:false,moved:false};
    return;
  }
  // ZONE DROITE : tricks
  if(tg){pop();return;} // 2e doigt a droite : pop avec l'etat courant (ex. crouch gauche tenu + tap = ollie charge)
  tg={id:t.identifier,x:p.x,y:p.y,t0:performance.now(),decoded:0,pressed:false,holdD:0,holdU:false,upT:0,timer:null};
  tg.timer=setTimeout(()=>{ // press : pop contextuel, held reste vrai tant que le doigt est pose
    if(!tg||tg.decoded||tg.pressed)return;
    tg.pressed=true;touchPop({});
  },PRESS_MS);
},{passive:false});
function tgLMove(t){ // ZONE GAUCHE : swipe HAUT = ollie (charge si crouch tenu), swipe BAS = crouch
  if(tgL.done)return;
  const p=cvPt(t),dx=p.x-tgL.x,dy=p.y-tgL.y;
  if(Math.hypot(dx,dy)<SWIPE)return;
  tgL.moved=true;idleT=0;
  if(state!=='play'||P.crash>0)return;
  const f=swipeFlags(dx,dy);
  if(f.u){
    if(P.air){tgL.done=true;return;} // en l'air la zone gauche ne fait rien sur un swipe
    if(tgL.crouch){KD.d=false;tgL.crouch=false;touchPop({d:true});} // crouch tenu + haut = ollie charge
    else touchPop({d:true});                                        // haut = ollie
    tgL.done=true;
  }else if(f.d&&!tgL.crouch&&!P.air){
    KD.d=true;lastDownF=frame;tgL.crouch=true; // crouch : charge tant que le doigt reste pose
    tgL.x=p.x;tgL.y=p.y; // le swipe haut suivant se mesure depuis le point bas
  }
  // swipes purement horizontaux : ignores dans la zone gauche
}
wrap.addEventListener('touchmove',e=>{
  e.preventDefault();
  if(tgL){let tl=null;for(const c of e.changedTouches)if(c.identifier===tgL.id)tl=c;if(tl)tgLMove(tl);}
  if(!tg)return;
  let t=null;for(const c of e.changedTouches)if(c.identifier===tg.id)t=c;
  if(!t)return;
  const p=cvPt(t),dx=p.x-tg.x,dy=p.y-tg.y,now=performance.now(),dist=Math.hypot(dx,dy);
  // des que le doigt commence a glisser, on annule le press : c'est un swipe qui demarre
  if(dist>SWIPE*.5&&tg.timer&&!tg.pressed){clearTimeout(tg.timer);tg.timer=null;}
  // 1er swipe : seuil court ; re-swipe (mm doigt) : seuil et delai plus grands pour eviter
  // qu'un long swipe continu ne decode plusieurs tricks (ex. 180 -> 360 involontaire)
  if(dist<(tg.decoded?SWIPE*2.5:SWIPE))return;
  const f=swipeFlags(dx,dy),diag=(f.l||f.r)&&(f.u||f.d);
  if(tg.decoded){ // meme direction sur le meme toucher : jamais re-decode (un long swipe = UN trick)
    const same=tg.pf&&f.l===tg.pf.l&&f.r===tg.pf.r&&f.u===tg.pf.u&&f.d===tg.pf.d;
    if(same||now-tg.decT<120){tg.x=p.x;tg.y=p.y;return;} // pour 360+ : re-swipe (nouveau toucher) ou inverse
  }
  if(tg.timer){clearTimeout(tg.timer);tg.timer=null;}
  tg.x=p.x;tg.y=p.y;tg.decoded++;tg.decT=now;tg.pf=f;idleT=0;
  if(state!=='play'||P.crash>0)return;
  if(P.air||tg.pressed){        // AIR : flips / grabs / spins (re-swipe G/D = +180)
    touchPop(f);
  }else if(P.grind){            // RAIL
    if(diag)touchPop(f);                                 // pop out + flip
    else if(f.l)pendL=true;                              // lean F/S
    else if(f.r)pendR=true;                              // lean B/S
    else if(f.d){KD.d=true;lastDownF=frame;tg.holdD=2;}  // drop du rail
    else if(f.u){KD.u=true;tg.holdU=true;}
  }else if(P.wall){             // MUR
    if(f.l)pendL=true;else if(f.r)pendR=true;            // boardslide F/S / B/S
    else if(f.u){KD.u=true;tg.holdU=true;}               // continuer la montee
    else if(f.d){KD.u=false;tg.holdU=false;}             // redescendre
    else if(diag)touchPop(f);
  }else{                        // SOL
    if((tg.holdD||leftCrouch())&&(f.l||f.r))touchPop({l:f.l,r:f.r,d:true}); // crouch tenu (droit ou pouce gauche) + swipe G/D = flip charge
    else if(diag)touchPop(f);                                     // ollie + flip direct
    else if(f.d){KD.d=true;tg.holdD=1;}                           // crouch : charge l'ollie
    else if(f.u){KD.u=true;tg.holdU=true;tg.upT=performance.now();} // tenu = wall ride ; bref = shuvit
    else if(P.man)touchPop(f);                                    // en manual : hop 180 (retombe en manual)
    else if((f.l||f.r)&&P.slide<=0&&P.rev<=0)startManual(!!f.r);  // manual / nose manual
  }
},{passive:false});
wrap.addEventListener('touchend',e=>{
  if(tgL){ // ZONE GAUCHE
    let tl=null;for(const c of e.changedTouches)if(c.identifier===tgL.id)tl=c;
    if(tl){
      const wasCrouch=tgL.crouch,moved=tgL.moved;
      tgLClear();
      if(state==='play'&&P.crash<=0&&!wasCrouch&&!moved)touchPop({}); // tap sec = petit saut
      return; // relacher un crouch sans swipe haut = annule, pas de saut
    }
  }
  if(!tg){held=false;return;}
  let t=null;for(const c of e.changedTouches)if(c.identifier===tg.id)t=c;
  if(!t)return; // un autre doigt s'est leve : on garde le geste principal
  const wasPress=tg.pressed,dec=tg.decoded,hD=tg.holdD,hU=tg.holdU,upT=tg.upT;
  tgClear();held=false;
  if(state!=='play'||P.crash>0)return;
  if(hD===1&&!P.air)touchPop({d:true});                                        // relache le crouch = ollie charge
  else if(hU&&upT&&performance.now()-upT<220&&!P.wall&&!P.air)touchPop({u:true}); // haut bref = pop shuvit
  else if(!wasPress&&!dec)touchPop({});                                        // tap sec = pop contextuel
},{passive:false});
wrap.addEventListener('touchcancel',()=>{tgClear();tgLClear();held=false;},{passive:false});
wrap.addEventListener('mousedown',e=>{if(fsHit(e.clientX,e.clientY)){toggleFS();return;}pop();});
wrap.addEventListener('mouseup',()=>{held=false;});
const balink=document.getElementById('fred-game-link');
for(const ev of['mousedown','mouseup','touchstart','touchend','click'])
  balink.addEventListener(ev,e=>e.stopPropagation());
//============================================================ MAIN LOOP
function loop(){
  requestAnimationFrame(loop);
  frame++;
  balink.style.display=state==='over'?'block':'none';
  if(state==='play'||state==='outro')update();
  pendL=pendR=false;upL=upR=false;
  tickMusic();
  draw();
}
loop();
